import CryptoJS from "crypto-js";
import isEmpty from "lodash/isEmpty";
const getDateListYears = (currentYear) => {
  return Array(100)
    .fill()
    .map((ele, i) => {
      const value = i + currentYear - 99;
      return {
        key: value,
        label: "" + value,
        value: "" + value,
      };
    })
    .sort((a, b) => b.key - a.key);
};

export const getHijriYearOfBirthList = () => {
  const currentYear = new Date().getFullYear();
  const hijriYear = Math.round((currentYear - 623) * (33 / 32));
  return getDateListYears(hijriYear);
};
export const getGregYearOfBirthList = () => {
  const gregYear = new Date().getFullYear();
  return getDateListYears(gregYear);
};

export const getNumberRepresentedLanguageCode = (language) => {
  return isArabic(language) ? "1" : "2";
};

// language > 'en' or 'ar'
export const getOneLetterLanguageCode = (language) => {
  return language.slice(0, 1).toUpperCase();
};

// language > 'en' or 'ar'
export const getTwoLetterLanguageCode = (language) => {
  return language.toUpperCase();
};

export const getNumberLanguageMapper = (language) => {
  return isArabic(language) ? "1" : "2";
};

export const numberWithCommas = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const isValidEmail = (email) => {
  return /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
    email
  );
};
export const isValidSaudiIDOrIQama = (idNumber) => {
  return /^[1,2]{1}[0-9]{9}$/i.test(idNumber);
};

export const isValidGDP = (idNumber) => {
  return /^[7]{1}[0-9]{9}$/i.test(idNumber);
};
export const isValidCRNumber = (idNumber) => {
  return /^[0-9]{10}$/i.test(idNumber);
};
export const isValidactivePolicyNumber = (policyNumber) => {
  return /[0-9]$/i.test(policyNumber);
};

export const isValidSaudiPhoneNumber = (value) => {
  return /^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/.test(value);
};
export const isValidSaudiPhoneNumberKYC = (value) => {
  return /^\+966[1-9]\d{8}$/.test(value);
};

export const isEnglishOnly = (value) => {
  return /[a-zA-Z\s]$/i.test(value);
};

export const isNumber = (value) => {
  const regex = /[0-9]+/g;
  return regex.test(value);
};

export const isAlphaNumeric = (e) => {
  const charCode = e.charCode;
  // Block Arabic numerals (Unicode ranges: \u0660-\u0669, \u06F0-\u06F9)
  if ((charCode >= 0x0660 && charCode <= 0x0669) || (charCode >= 0x06F0 && charCode <= 0x06F9)) {
    e.preventDefault();
  }
  const re = /^[a-zA-Z0-9]+$/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

export const isArabic = (language) => {
  return language === "ar";
};

export const prepareMobileNumber = (value, removePlus, onlyNum = false) => {
  let number = value?.indexOf("0") === 0 ? value.substring(1) : value;
  if (number) {
    if (number.indexOf("+966") === 0) {
      number = number.substring(4);
    }
    if (number.indexOf("966") === 0) {
      number = number.substring(3);
    }
    if (onlyNum) return number;
    return removePlus ? "966" + number : "+966" + number;
  } else return "";
};

export const numbersOnly = (event) => {
  const regex = /[0-9]+/g;
  return regex.test(event.key);
};

export const getProductsCodes = () => {
  return {
    SANAD: "MotorImtiazeTP",
    SANAD_PLUS: "PRMotorImtiazeSP",
    AL_SHAMEL: "PRMotorImtiazeCO",
  };
};

export const isSaudi = (nationalId) => {
  return nationalId && nationalId[0] === "1";
};

export const normalizeSaudiPhoneNumber = (phoneNumber) => {
  const digitsOnly = phoneNumber.replace(/\D/g, "");

  if (digitsOnly.length === 9) {
    return "+966" + digitsOnly;
  } else {
    const saudiRegex = /^\+966\d{9}$/;

    if (saudiRegex.test(digitsOnly)) {
      return digitsOnly;
    } else {
      return null;
    }
  }
};

export const mechanicalFeatures = [
  {
    label: "engine",
    price: "20,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "gearbox",
    price: "10,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "differential",
    price: "10,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "turbo-assembly",
    price: "5,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "management-system",
    price: "5,000",
    codes: ["MC_GD", "MC_SI"],
  },

  {
    label: "prop-shaft-CV-joints",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },

  {
    label: "steering-mechanism",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "wheel-bearings",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "braking-system",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "fuel-system",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "electrical-components",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "electrical-ignition",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "suspension",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "cylinder-head-gasket",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "radiator",
    price: "4,000",
    codes: ["MC_GD"],
  },

  {
    label: "air-conditioner",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "overheating",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "cambelt-failure",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "clutch",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "electric-fans-sunroof",
    price: "4,000",
    codes: ["MC_GD"],
  },
];

export const getPercentageValues = (value, size) => {
  let chunks = [];
  let sum = value;
  if (size === 1) {
    return [value];
  } else {
    for (let i = 0; i < size; i++) {
      if ((value / size) % 1 !== 0) {
        if (sum > 75) {
          sum -= 50;
        } else if (sum > 25) {
          sum -= 25;
        }
        chunks[i] = sum;
      } else {
        chunks[i] = value / size;
      }
    }
    return chunks;
  }
};

export const deleteByKey = (key, { [key]: deletedKey, ...others }) => others;

export const formatDate = (d = new Date()) => {
  return [
    d.getFullYear(),
    ("0" + (d.getMonth() + 1)).slice(-2),
    ("0" + d.getDate()).slice(-2),
  ].join("-");
};

export const isFormFieldValid = (formik, name) => !!(formik.submitCount > 0 && formik.errors[name]);

export const getFormErrorMessage = (formik, name) => {
  return isFormFieldValid(formik, name) && <small className="p-error">{formik.errors[name]}</small>;
};

export const generateOTP = () => {
  let digits = "0123456789";
  let OTP = "";
  for (let i = 0; i < 4; i++) {
    OTP += digits[Math.floor(Math.random() * 10)];
  }
  return OTP;
};

export const NationalityList = [
  {
    nationality_descAr: "أخرى",
    nationality_descEn: "Other",
    nationality_code: "0",
  },
  {
    nationality_descAr: "سعودي",
    nationality_descEn: "SAUDI",
    nationality_code: "1",
  },
  {
    nationality_descAr: "أمريكي",
    nationality_descEn: "AMERICAN",
    nationality_code: "2",
  },
  {
    nationality_descAr: "بنغلاديشي",
    nationality_descEn: "BANGLADESHI",
    nationality_code: "3",
  },
  {
    nationality_descAr: "بريطاني",
    nationality_descEn: "BRITISH",
    nationality_code: "4",
  },
  {
    nationality_descAr: "مصر",
    nationality_descEn: "EGYPTIAN",
    nationality_code: "5",
  },
  {
    nationality_descAr: "فلبيني",
    nationality_descEn: "FILIPINO",
    nationality_code: "6",
  },
  {
    nationality_descAr: "الهند",
    nationality_descEn: "INDIAN",
    nationality_code: "7",
  },
  {
    nationality_descAr: "باكستاني",
    nationality_descEn: "PAKISTANI",
    nationality_code: "8",
  },
  {
    nationality_descAr: "يمني",
    nationality_descEn: "SRI LANKAN",
    nationality_code: "9",
  },
  {
    nationality_descAr: "سوداني",
    nationality_descEn: "SUDANESE",
    nationality_code: "10",
  },
  {
    nationality_descAr: "يمني",
    nationality_descEn: "YEMENI",
    nationality_code: "11",
  },
  {
    nationality_descAr: "أخرى",
    nationality_descEn: "OTHERS",
    nationality_code: "12",
  },
  {
    nationality_descAr: "عراقي",
    nationality_descEn: "IRAQI",
    nationality_code: "20",
  },
  {
    nationality_descAr: "لبناني",
    nationality_descEn: "LEBANEASE",
    nationality_code: "21",
  },
  {
    nationality_descAr: "إماراتي",
    nationality_descEn: "EMIRATI",
    nationality_code: "68",
  },
  {
    nationality_descAr: "بجريني",
    nationality_descEn: "BAHRAINI",
    nationality_code: "80",
  },
  {
    nationality_descAr: "غير معروف ",
    nationality_descEn: "UNKNOWN!",
    nationality_code: "99",
  },
  {
    nationality_descAr: "كويتي",
    nationality_descEn: "KUWAITI",
    nationality_code: "100",
  },
  {
    nationality_descAr: "أفغانستاني",
    nationality_descEn: "AFGHANISTAN",
    nationality_code: "101",
  },
  {
    nationality_descAr: "ألبانيا",
    nationality_descEn: "ALBANIA",
    nationality_code: "102",
  },
  {
    nationality_descAr: "جزائري",
    nationality_descEn: "ALGERIA",
    nationality_code: "103",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "AMERICAN SAMOA",
    nationality_code: "104",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ANDORRA",
    nationality_code: "105",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ANGOLA",
    nationality_code: "106",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ANGUILLA",
    nationality_code: "107",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ANTARCTICA",
    nationality_code: "108",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ANTIGUA AND BARBUDA",
    nationality_code: "109",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ARGENTINA",
    nationality_code: "110",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ARMENIA",
    nationality_code: "111",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "ARUBA",
    nationality_code: "112",
  },
  {
    nationality_descAr: "أستراليا",
    nationality_descEn: "AUSTRALIA",
    nationality_code: "113",
  },
  {
    nationality_descAr: "النمسا",
    nationality_descEn: "AUSTRIA",
    nationality_code: "114",
  },
  {
    nationality_descAr: "أذربيجان",
    nationality_descEn: "AZERBAIJAN",
    nationality_code: "115",
  },
  {
    nationality_descAr: "الباهاما",
    nationality_descEn: "BAHAMAS",
    nationality_code: "116",
  },
  {
    nationality_descAr: "بربادوس",
    nationality_descEn: "BARBADOS",
    nationality_code: "117",
  },
  {
    nationality_descAr: "بيلاروسيا",
    nationality_descEn: "BELARUS",
    nationality_code: "118",
  },
  {
    nationality_descAr: "بلجيكا",
    nationality_descEn: "BELGIUM",
    nationality_code: "119",
  },
  {
    nationality_descAr: "بليز",
    nationality_descEn: "BELIZE",
    nationality_code: "120",
  },
  {
    nationality_descAr: "بنين",
    nationality_descEn: "BENIN",
    nationality_code: "121",
  },
  {
    nationality_descAr: "جزر برمودا",
    nationality_descEn: "BERMUDA",
    nationality_code: "122",
  },
  {
    nationality_descAr: "بوتانية",
    nationality_descEn: "BHUTAN",
    nationality_code: "123",
  },
  {
    nationality_descAr: "بوليفية",
    nationality_descEn: "BOLIVIA",
    nationality_code: "124",
  },
  {
    nationality_descAr: "البوسنة والهرسك",
    nationality_descEn: "BOSNIA AND HERZEGOVINA",
    nationality_code: "125",
  },
  {
    nationality_descAr: "بوتسوانا",
    nationality_descEn: "BOTSWANA",
    nationality_code: "126",
  },
  {
    nationality_descAr: "برازيل",
    nationality_descEn: "BRAZIL",
    nationality_code: "127",
  },
  {
    nationality_descAr: "بروناي دار السلام",
    nationality_descEn: "BRUNEI DARUSSALAM",
    nationality_code: "128",
  },
  {
    nationality_descAr: "بلغاريا",
    nationality_descEn: "BULGARIA",
    nationality_code: "129",
  },
  {
    nationality_descAr: "بوركينا فاسو",
    nationality_descEn: "BURKINA FASO",
    nationality_code: "130",
  },
  {
    nationality_descAr: "بوروندي",
    nationality_descEn: "BURUNDI",
    nationality_code: "131",
  },
  {
    nationality_descAr: "كمبوديا",
    nationality_descEn: "CAMBODIA",
    nationality_code: "132",
  },
  {
    nationality_descAr: "كاميرون",
    nationality_descEn: "CAMEROON",
    nationality_code: "133",
  },
  {
    nationality_descAr: "كندا",
    nationality_descEn: "CANADA",
    nationality_code: "134",
  },
  {
    nationality_descAr: "كابو فيردي",
    nationality_descEn: "CAPE VERDE",
    nationality_code: "135",
  },
  {
    nationality_descAr: "جزيرة كايمان",
    nationality_descEn: "CAYMAN ISLANDS",
    nationality_code: "136",
  },
  {
    nationality_descAr: "جمهورية أفريقيا الوسطى",
    nationality_descEn: "CENTRAL AFRICAN REPUBLIC",
    nationality_code: "137",
  },
  {
    nationality_descAr: "تشاد",
    nationality_descEn: "CHAD",
    nationality_code: "138",
  },
  {
    nationality_descAr: "تشيلي",
    nationality_descEn: "CHILE",
    nationality_code: "139",
  },
  {
    nationality_descAr: "الصين",
    nationality_descEn: "CHINA",
    nationality_code: "140",
  },
  {
    nationality_descAr: "كولومبيا",
    nationality_descEn: "COLOMBIA",
    nationality_code: "141",
  },
  {
    nationality_descAr: "جزر القمر",
    nationality_descEn: "COMOROS",
    nationality_code: "142",
  },
  {
    nationality_descAr: "جمهورية الكونغو الديموقراطية",
    nationality_descEn: "DEMOCRATIC REPUBLIC OF THE CONGO (KINSHASA)",
    nationality_code: "143",
  },
  {
    nationality_descAr: "جمهورية الكونغو برازفيل",
    nationality_descEn: "CONGO REPUBLIC OF BRAZZAVILLE",
    nationality_code: "144",
  },
  {
    nationality_descAr: "جزر كوك",
    nationality_descEn: "COOK ISLANDS",
    nationality_code: "145",
  },
  {
    nationality_descAr: "كوستاريكا",
    nationality_descEn: "COSTA RICA",
    nationality_code: "146",
  },
  {
    nationality_descAr: "ساحل العاج",
    nationality_descEn: "COTE D'IVOIRE",
    nationality_code: "147",
  },
  {
    nationality_descAr: "كرواتيا",
    nationality_descEn: "CROATIA",
    nationality_code: "148",
  },
  {
    nationality_descAr: "كوبا",
    nationality_descEn: "CUBA",
    nationality_code: "149",
  },
  {
    nationality_descAr: "قبرص",
    nationality_descEn: "CYPRUS",
    nationality_code: "150",
  },
  {
    nationality_descAr: "الجمهورية التشيكية",
    nationality_descEn: "CZECH REPUBLIC",
    nationality_code: "151",
  },
  {
    nationality_descAr: "دينمارك",
    nationality_descEn: "DENMARK",
    nationality_code: "152",
  },
  {
    nationality_descAr: "جيبوتي",
    nationality_descEn: "DJIBOUTI",
    nationality_code: "153",
  },
  {
    nationality_descAr: "دومينيكا",
    nationality_descEn: "DOMINICA",
    nationality_code: "154",
  },
  {
    nationality_descAr: "جمهورية دومينيكا",
    nationality_descEn: "DOMINICAN REPUBLIC",
    nationality_code: "155",
  },
  {
    nationality_descAr: "الأكوادور",
    nationality_descEn: "ECUADOR",
    nationality_code: "156",
  },
  {
    nationality_descAr: "السلفادور",
    nationality_descEn: "EL SALVADOR",
    nationality_code: "157",
  },
  {
    nationality_descAr: "غينيا الأستوائية",
    nationality_descEn: "EQUATORIAL GUINEA",
    nationality_code: "158",
  },
  {
    nationality_descAr: "إرتيريا",
    nationality_descEn: "ERITREA",
    nationality_code: "159",
  },
  {
    nationality_descAr: "إستونيا",
    nationality_descEn: "ESTONIA",
    nationality_code: "160",
  },
  {
    nationality_descAr: "إثيوبيا",
    nationality_descEn: "ETHIOPIA",
    nationality_code: "161",
  },
  {
    nationality_descAr: "جزر فوكلاند",
    nationality_descEn: "FALKLAND ISLANDS",
    nationality_code: "162",
  },
  {
    nationality_descAr: "عماني",
    nationality_descEn: "OMANI",
    nationality_code: "163",
  },
  {
    nationality_descAr: "جزر فاروس",
    nationality_descEn: "FAROE ISLANDS",
    nationality_code: "164",
  },
  {
    nationality_descAr: "فيجي",
    nationality_descEn: "FIJI",
    nationality_code: "165",
  },
  {
    nationality_descAr: "فنلندا",
    nationality_descEn: "FINLAND",
    nationality_code: "166",
  },
  {
    nationality_descAr: "فرنسا",
    nationality_descEn: "FRANCE",
    nationality_code: "167",
  },
  {
    nationality_descAr: "غيانا الفرنسية",
    nationality_descEn: "FRENCH GUIANA",
    nationality_code: "168",
  },
  {
    nationality_descAr: "بولينيزيا الفرنسية",
    nationality_descEn: "FRENCH POLYNESIA",
    nationality_code: "169",
  },
  {
    nationality_descAr: "غابون",
    nationality_descEn: "GABON",
    nationality_code: "170",
  },
  {
    nationality_descAr: "قطري",
    nationality_descEn: "QATARI",
    nationality_code: "171",
  },
  {
    nationality_descAr: "غامبيا",
    nationality_descEn: "GAMBIA",
    nationality_code: "172",
  },
  {
    nationality_descAr: "جورجيا",
    nationality_descEn: "GEORGIA",
    nationality_code: "173",
  },
  {
    nationality_descAr: "ألمانيا",
    nationality_descEn: "GERMANY",
    nationality_code: "174",
  },
  {
    nationality_descAr: "غانا",
    nationality_descEn: "GHANA",
    nationality_code: "175",
  },
  {
    nationality_descAr: "جبل طارق",
    nationality_descEn: "GIBRALTAR",
    nationality_code: "176",
  },
  {
    nationality_descAr: "اليونان",
    nationality_descEn: "GREECE",
    nationality_code: "177",
  },
  {
    nationality_descAr: "جرينلاند",
    nationality_descEn: "GREENLAND",
    nationality_code: "178",
  },
  {
    nationality_descAr: "غرينادا",
    nationality_descEn: "GRENADA",
    nationality_code: "179",
  },
  {
    nationality_descAr: "جوادلوب",
    nationality_descEn: "GUADELOUPE",
    nationality_code: "180",
  },
  {
    nationality_descAr: "جوام",
    nationality_descEn: "GUAM",
    nationality_code: "181",
  },
  {
    nationality_descAr: "جواتيمالا",
    nationality_descEn: "GUATEMALA",
    nationality_code: "182",
  },
  {
    nationality_descAr: "غينيا",
    nationality_descEn: "GUINEA",
    nationality_code: "183",
  },
  {
    nationality_descAr: "غينيا بيساو",
    nationality_descEn: "GUINEA-BISSAU",
    nationality_code: "184",
  },
  {
    nationality_descAr: "غيانا",
    nationality_descEn: "GUYANA",
    nationality_code: "185",
  },
  {
    nationality_descAr: "هايتي",
    nationality_descEn: "HAITI",
    nationality_code: "186",
  },
  {
    nationality_descAr: "هندوراس",
    nationality_descEn: "HONDURAS",
    nationality_code: "187",
  },
  {
    nationality_descAr: "هونغ كونغ",
    nationality_descEn: "HONG KONG",
    nationality_code: "188",
  },
  {
    nationality_descAr: "هنغاريا",
    nationality_descEn: "HUNGARY",
    nationality_code: "189",
  },
  {
    nationality_descAr: "أيسلندا",
    nationality_descEn: "ICELAND",
    nationality_code: "190",
  },
  {
    nationality_descAr: "إندونيسيا",
    nationality_descEn: "INDONESIA",
    nationality_code: "191",
  },
  {
    nationality_descAr: "إيران",
    nationality_descEn: "IRAN",
    nationality_code: "192",
  },
  {
    nationality_descAr: "إيرلاندا",
    nationality_descEn: "IRELAND",
    nationality_code: "193",
  },
  {
    nationality_descAr: "إسرائيل",
    nationality_descEn: "ISRAEL",
    nationality_code: "194",
  },
  {
    nationality_descAr: "إيطاليا",
    nationality_descEn: "ITALY",
    nationality_code: "195",
  },
  {
    nationality_descAr: "جاميكا",
    nationality_descEn: "JAMAICA",
    nationality_code: "196",
  },
  {
    nationality_descAr: "يابان",
    nationality_descEn: "JAPAN",
    nationality_code: "197",
  },
  {
    nationality_descAr: "الأردن",
    nationality_descEn: "JORDAN",
    nationality_code: "198",
  },
  {
    nationality_descAr: "كازاخستان",
    nationality_descEn: "KAZAKHSTAN",
    nationality_code: "199",
  },
  {
    nationality_descAr: "كينيا",
    nationality_descEn: "KENYA",
    nationality_code: "200",
  },
  {
    nationality_descAr: "كيريباتي",
    nationality_descEn: "KIRIBATI",
    nationality_code: "201",
  },
  {
    nationality_descAr: "كوريا، (كوريا الشمالية)",
    nationality_descEn: "KOREA, (NORTH KOREA)",
    nationality_code: "202",
  },
  {
    nationality_descAr: "كوريا، ( كوريا الجنوبية)",
    nationality_descEn: "KOREA (SOUTH KOREA)",
    nationality_code: "203",
  },
  {
    nationality_descAr: "قيرغيزستان",
    nationality_descEn: "KYRGYZSTAN",
    nationality_code: "204",
  },
  {
    nationality_descAr: "لاو، جمهورية الكونغو الديموقراطية",
    nationality_descEn: "LAO, PDR",
    nationality_code: "205",
  },
  {
    nationality_descAr: "لاتفيا",
    nationality_descEn: "LATVIA",
    nationality_code: "206",
  },
  {
    nationality_descAr: "ليستوتو",
    nationality_descEn: "LESOTHO",
    nationality_code: "207",
  },
  {
    nationality_descAr: "ليبيريا",
    nationality_descEn: "LIBERIA",
    nationality_code: "208",
  },
  {
    nationality_descAr: "ليبيا",
    nationality_descEn: "LIBYA",
    nationality_code: "209",
  },
  {
    nationality_descAr: "ليختنشتاين",
    nationality_descEn: "LIECHTENSTEIN",
    nationality_code: "210",
  },
  {
    nationality_descAr: "ليثوانا",
    nationality_descEn: "LITHUANIA",
    nationality_code: "211",
  },
  {
    nationality_descAr: "لوكسمبورغ",
    nationality_descEn: "LUXEMBOURG",
    nationality_code: "212",
  },
  {
    nationality_descAr: "ماكاو",
    nationality_descEn: "MACAO",
    nationality_code: "213",
  },
  {
    nationality_descAr: "مقدونيا",
    nationality_descEn: "MACEDONIA, REP. OF",
    nationality_code: "214",
  },
  {
    nationality_descAr: "مدغشقر",
    nationality_descEn: "MADAGASCAR",
    nationality_code: "215",
  },
  {
    nationality_descAr: "مالاوي",
    nationality_descEn: "MALAWI",
    nationality_code: "216",
  },
  {
    nationality_descAr: "ماليزيا",
    nationality_descEn: "MALAYSIA",
    nationality_code: "217",
  },
  {
    nationality_descAr: "مالديف",
    nationality_descEn: "MALDIVES",
    nationality_code: "218",
  },
  {
    nationality_descAr: "مالي",
    nationality_descEn: "MALI",
    nationality_code: "219",
  },
  {
    nationality_descAr: "مالطا",
    nationality_descEn: "MALTA",
    nationality_code: "220",
  },
  {
    nationality_descAr: "جزر مارشال",
    nationality_descEn: "MARSHALL ISLANDS",
    nationality_code: "221",
  },
  {
    nationality_descAr: "مارتينيك",
    nationality_descEn: "MARTINIQUE",
    nationality_code: "222",
  },
  {
    nationality_descAr: "موريتانيا",
    nationality_descEn: "MAURITANIA",
    nationality_code: "223",
  },
  {
    nationality_descAr: "موريشيوس",
    nationality_descEn: "MAURITIUS",
    nationality_code: "224",
  },
  {
    nationality_descAr: "المكسيك",
    nationality_descEn: "MEXICO",
    nationality_code: "225",
  },
  {
    nationality_descAr: "ميكرونيزيا",
    nationality_descEn: "MICRONESIA",
    nationality_code: "226",
  },
  {
    nationality_descAr: "مولدوفا",
    nationality_descEn: "MOLDOVA",
    nationality_code: "227",
  },
  {
    nationality_descAr: "موناكو",
    nationality_descEn: "MONACO",
    nationality_code: "228",
  },
  {
    nationality_descAr: "منغوليا",
    nationality_descEn: "MONGOLIA",
    nationality_code: "229",
  },
  {
    nationality_descAr: "مونتينيغرو",
    nationality_descEn: "MONTENEGRO",
    nationality_code: "230",
  },
  {
    nationality_descAr: "",
    nationality_descEn: "MONTSERRAT",
    nationality_code: "231",
  },
  {
    nationality_descAr: "المغرب",
    nationality_descEn: "MOROCCO",
    nationality_code: "232",
  },
  {
    nationality_descAr: "موزنبيق",
    nationality_descEn: "MOZAMBIQUE",
    nationality_code: "233",
  },
  {
    nationality_descAr: "ميانمار",
    nationality_descEn: "MYANMAR",
    nationality_code: "234",
  },
  {
    nationality_descAr: "نامبيا",
    nationality_descEn: "NAMIBIA",
    nationality_code: "235",
  },
  {
    nationality_descAr: "ناورو",
    nationality_descEn: "NAURU",
    nationality_code: "236",
  },
  {
    nationality_descAr: "النيبال",
    nationality_descEn: "NEPAL",
    nationality_code: "237",
  },
  {
    nationality_descAr: "هولندا",
    nationality_descEn: "NETHERLANDS",
    nationality_code: "238",
  },
  {
    nationality_descAr: "جزر الأنتيل الهولندية",
    nationality_descEn: "NETHERLANDS ANTILLES",
    nationality_code: "239",
  },
  {
    nationality_descAr: "كاليدونيا الجديدة",
    nationality_descEn: "NEW CALEDONIA",
    nationality_code: "240",
  },
  {
    nationality_descAr: "نيوزلاندا",
    nationality_descEn: "NEW ZEALAND",
    nationality_code: "241",
  },
  {
    nationality_descAr: "نيكاراغو",
    nationality_descEn: "NICARAGUA",
    nationality_code: "242",
  },
  {
    nationality_descAr: "النيجر",
    nationality_descEn: "NIGER",
    nationality_code: "243",
  },
  {
    nationality_descAr: "نيجيريا",
    nationality_descEn: "NIGERIA",
    nationality_code: "244",
  },
  {
    nationality_descAr: "نييوي",
    nationality_descEn: "NIUE",
    nationality_code: "245",
  },
  {
    nationality_descAr: "جزر مارينا الشمالية",
    nationality_descEn: "NORTHERN MARIANA ISLANDS",
    nationality_code: "246",
  },
  {
    nationality_descAr: "النرويج",
    nationality_descEn: "NORWAY",
    nationality_code: "247",
  },
  {
    nationality_descAr: "بالاو",
    nationality_descEn: "PALAU",
    nationality_code: "248",
  },
  {
    nationality_descAr: "فلسطين",
    nationality_descEn: "PALESTINE",
    nationality_code: "249",
  },
  {
    nationality_descAr: "بنما",
    nationality_descEn: "PANAMA",
    nationality_code: "250",
  },
  {
    nationality_descAr: "بابوا غينيا الجديدة",
    nationality_descEn: "PAPUA NEW GUINEA",
    nationality_code: "251",
  },
  {
    nationality_descAr: "باراغوي",
    nationality_descEn: "PARAGUAY",
    nationality_code: "252",
  },
  {
    nationality_descAr: "بيرو",
    nationality_descEn: "PERU",
    nationality_code: "253",
  },
  {
    nationality_descAr: "بولندا",
    nationality_descEn: "POLAND",
    nationality_code: "254",
  },
  {
    nationality_descAr: "برتغال",
    nationality_descEn: "PORTUGAL",
    nationality_code: "255",
  },
  {
    nationality_descAr: "بورتوريكو",
    nationality_descEn: "PUERTO RICO",
    nationality_code: "256",
  },
  {
    nationality_descAr: "جزيرة ريونيون",
    nationality_descEn: "REUNION ISLAND",
    nationality_code: "257",
  },
  {
    nationality_descAr: "رومانيا",
    nationality_descEn: "ROMANIA",
    nationality_code: "258",
  },
  {
    nationality_descAr: "روسيا",
    nationality_descEn: "RUSSIA",
    nationality_code: "259",
  },
  {
    nationality_descAr: "رواندا",
    nationality_descEn: "RWANDA",
    nationality_code: "260",
  },
  {
    nationality_descAr: "سانت كيتس ونيفيس",
    nationality_descEn: "SAINT KITTS AND NEVIS",
    nationality_code: "261",
  },
  {
    nationality_descAr: "سانت لوسيا",
    nationality_descEn: "SAINT LUCIA",
    nationality_code: "262",
  },
  {
    nationality_descAr: "غرينادين",
    nationality_descEn: "GRENADINES",
    nationality_code: "263",
  },
  {
    nationality_descAr: "ساموا",
    nationality_descEn: "SAMOA",
    nationality_code: "264",
  },
  {
    nationality_descAr: "سان مارينة",
    nationality_descEn: "SAN MARINO",
    nationality_code: "265",
  },
  {
    nationality_descAr: "ساو تومي وبرينسيب",
    nationality_descEn: "SAO TOME AND PRINCIPE",
    nationality_code: "266",
  },
  {
    nationality_descAr: "السنغال",
    nationality_descEn: "SENEGAL",
    nationality_code: "267",
  },
  {
    nationality_descAr: "صربيا",
    nationality_descEn: "SERBIA",
    nationality_code: "268",
  },
  {
    nationality_descAr: "سيشل",
    nationality_descEn: "SEYCHELLES",
    nationality_code: "269",
  },
  {
    nationality_descAr: "سيراليون",
    nationality_descEn: "SIERRA LEONE",
    nationality_code: "270",
  },
  {
    nationality_descAr: "سنغافورة",
    nationality_descEn: "SINGAPORE",
    nationality_code: "271",
  },
  {
    nationality_descAr: "سلوفاكيا",
    nationality_descEn: "SLOVAKIA",
    nationality_code: "272",
  },
  {
    nationality_descAr: "سلوفينيا",
    nationality_descEn: "SLOVENIA",
    nationality_code: "273",
  },
  {
    nationality_descAr: "جزر سليمان",
    nationality_descEn: "SOLOMON ISLANDS",
    nationality_code: "274",
  },
  {
    nationality_descAr: "صوماليا",
    nationality_descEn: "SOMALIA",
    nationality_code: "275",
  },
  {
    nationality_descAr: "جنوب أفريقيا",
    nationality_descEn: "SOUTH AFRICA",
    nationality_code: "276",
  },
  {
    nationality_descAr: "أسبانيا",
    nationality_descEn: "SPAIN",
    nationality_code: "277",
  },
  {
    nationality_descAr: "سورينام",
    nationality_descEn: "SURINAME",
    nationality_code: "278",
  },
  {
    nationality_descAr: "سوازيلاند",
    nationality_descEn: "SWAZILAND",
    nationality_code: "279",
  },
  {
    nationality_descAr: "السويد",
    nationality_descEn: "SWEDEN",
    nationality_code: "280",
  },
  {
    nationality_descAr: "سويسرا",
    nationality_descEn: "SWITZERLAND",
    nationality_code: "281",
  },
  {
    nationality_descAr: "سوريا",
    nationality_descEn: "SYRIA",
    nationality_code: "282",
  },
  {
    nationality_descAr: "تايوان",
    nationality_descEn: "TAIWAN",
    nationality_code: "283",
  },
  {
    nationality_descAr: "طاجكستان",
    nationality_descEn: "TAJIKISTAN",
    nationality_code: "284",
  },
  {
    nationality_descAr: "تانزانيا",
    nationality_descEn: "TANZANIA",
    nationality_code: "285",
  },
  {
    nationality_descAr: "تايلاند",
    nationality_descEn: "THAILAND",
    nationality_code: "286",
  },
  {
    nationality_descAr: "التبت",
    nationality_descEn: "TIBET",
    nationality_code: "287",
  },
  {
    nationality_descAr: "تيمور الشرقية",
    nationality_descEn: "TIMOR-LESTE (EAST TIMOR)",
    nationality_code: "288",
  },
  {
    nationality_descAr: "توغو",
    nationality_descEn: "TOGO",
    nationality_code: "289",
  },
  {
    nationality_descAr: "توكيلو",
    nationality_descEn: "TOKELAU",
    nationality_code: "290",
  },
  {
    nationality_descAr: "تونغا",
    nationality_descEn: "TONGA",
    nationality_code: "291",
  },
  {
    nationality_descAr: "ترينيداد وتوباغو",
    nationality_descEn: "TRINIDAD AND TOBAGO",
    nationality_code: "292",
  },
  {
    nationality_descAr: "تونس",
    nationality_descEn: "TUNISIA",
    nationality_code: "293",
  },
  {
    nationality_descAr: "تركيا",
    nationality_descEn: "TURKEY",
    nationality_code: "294",
  },
  {
    nationality_descAr: "تركمانستان",
    nationality_descEn: "TURKMENISTAN",
    nationality_code: "295",
  },
  {
    nationality_descAr: "توفالو",
    nationality_descEn: "TUVALU",
    nationality_code: "296",
  },
  {
    nationality_descAr: "أوغندا",
    nationality_descEn: "UGANDA",
    nationality_code: "297",
  },
  {
    nationality_descAr: "أوكرانيا",
    nationality_descEn: "UKRAINE",
    nationality_code: "298",
  },
  {
    nationality_descAr: "أوروجواي",
    nationality_descEn: "URUGUAY",
    nationality_code: "299",
  },
  {
    nationality_descAr: "أوزبيكستان",
    nationality_descEn: "UZBEKISTAN",
    nationality_code: "300",
  },
  {
    nationality_descAr: "فانواتو",
    nationality_descEn: "VANUATU",
    nationality_code: "301",
  },
  {
    nationality_descAr: "فاتيكان",
    nationality_descEn: "VATICAN CITY STATE",
    nationality_code: "302",
  },
  {
    nationality_descAr: "فنزويلا",
    nationality_descEn: "VENEZUELA",
    nationality_code: "303",
  },
  {
    nationality_descAr: "فيتنام",
    nationality_descEn: "VIETNAM",
    nationality_code: "304",
  },
  {
    nationality_descAr: "جزر العذراء (البريطانية)",
    nationality_descEn: "VIRGIN ISLANDS (BRITISH)",
    nationality_code: "305",
  },
  {
    nationality_descAr: "الجزر العذراء (الولايات المتحدة)",
    nationality_descEn: "VIRGIN ISLANDS (U.S.)",
    nationality_code: "306",
  },
  {
    nationality_descAr: "جزر واليس وفوتونا",
    nationality_descEn: "WALLIS AND FUTUNA ISLANDS",
    nationality_code: "307",
  },
  {
    nationality_descAr: "الصحراء الغربية ",
    nationality_descEn: "WESTERN SAHARA",
    nationality_code: "308",
  },
  {
    nationality_descAr: "زامبيا",
    nationality_descEn: "ZAMBIA",
    nationality_code: "309",
  },
  {
    nationality_descAr: "زيمبابوي",
    nationality_descEn: "ZIMBABWE",
    nationality_code: "310",
  },
  {
    nationality_descAr: "المقيمين بجواز سعودي",
    nationality_descEn: "Resident with Saudi passport",
    nationality_code: "311",
  },
  {
    nationality_descAr: "غير متاح",
    nationality_descEn: "N/A",
    nationality_code: "312",
  },
  {
    nationality_descAr: "غير متاح",
    nationality_descEn: "N/A",
    nationality_code: "313",
  },
  {
    nationality_descAr: "كوسوفو",
    nationality_descEn: "Kosovo",
    nationality_code: "314",
  },
  {
    nationality_descAr: "قبيلة النزهة",
    nationality_descEn: "Al-Nazha Tribes",
    nationality_code: "315",
  },
  {
    nationality_descAr: "مقيم",
    nationality_descEn: "MUQEEM",
    nationality_code: "316",
  },
  {
    nationality_descAr: "غير البحرينيين",
    nationality_descEn: "Non-Bahrini",
    nationality_code: "317",
  },
  {
    nationality_descAr: "غير متاح",
    nationality_descEn: "N/A",
    nationality_code: "318",
  },
  {
    nationality_descAr: "صيربيا",
    nationality_descEn: "Serbia",
    nationality_code: "319",
  },
  {
    nationality_descAr: "غير متاح",
    nationality_descEn: "N/A",
    nationality_code: "320",
  },
  {
    nationality_descAr: "القبائل، النازحون، المتحالفون",
    nationality_descEn: "Tribes, IDP / allied",
    nationality_code: "321",
  },
  {
    nationality_descAr: "ميانمار/ جواز السفر البكستاني",
    nationality_descEn: "Myanmar/Pakistan Passport",
    nationality_code: "322",
  },
  {
    nationality_descAr: " ميانمار/ مقيم",
    nationality_descEn: "Myanmar/Resident",
    nationality_code: "323",
  },
  {
    nationality_descAr: "ميانمار/ جواز سفر بنقلاديش",
    nationality_descEn: "Myanmar/Bangladesh Passport",
    nationality_code: "324",
  },
  {
    nationality_descAr: "ميانمار/ جواز سفر بنقلاديش",
    nationality_descEn: "Myanmar/Bangladesh Passport",
    nationality_code: "325",
  },
  {
    nationality_descAr: "جنوب اليمن",
    nationality_descEn: "South Yemen",
    nationality_code: "326",
  },
  {
    nationality_descAr: "تايوان-الصين",
    nationality_descEn: "Taiwan-China",
    nationality_code: "327",
  },
  {
    nationality_descAr: "أخرى",
    nationality_descEn: "Other",
    nationality_code: "9999",
  },
];

export const nationalityCodeListAr = [
  {
    code: "AFG",
    name: "أفغانستان",
  },
  {
    code: "ALB",
    name: "ألبانيا",
  },
  {
    code: "DZA",
    name: "الجزائر",
  },
  {
    code: "ASM",
    name: "ساموا الأمريكية",
  },
  {
    code: "AND",
    name: "اندورا",
  },
  {
    code: "AGO",
    name: "أنجولا",
  },
  {
    code: "AIA",
    name: "أنجويلا",
  },
  {
    code: "ATA",
    name: "القطب الجنوبى",
  },
  {
    code: "ATG",
    name: "انتيجوا و باربودا",
  },
  {
    code: "ARG",
    name: "الارجنتين",
  },
  {
    code: "ARM",
    name: "ارمينيا",
  },
  {
    code: "ABW",
    name: "آروبا",
  },
  {
    code: "AUS",
    name: "استراليا",
  },
  {
    code: "AUT",
    name: "النمسا",
  },
  {
    code: "AZE",
    name: "اذربيجان",
  },
  {
    code: "BHS",
    name: "جزر البهاما",
  },
  {
    code: "BGD",
    name: "بنجلاديش",
  },
  {
    code: "BRB",
    name: "باربادوس",
  },
  {
    code: "BLR",
    name: "بيلاروس",
  },
  {
    code: "BEL",
    name: "بلجيكا",
  },
  {
    code: "BLZ",
    name: "بليز",
  },
  {
    code: "BEN",
    name: "بنين",
  },
  {
    code: "BMU",
    name: "برمودا",
  },
  {
    code: "BTN",
    name: "بوتان",
  },
  {
    code: "BOL",
    name: "بوليفيا",
  },
  {
    code: "BIH",
    name: "البوسنة",
  },
  {
    code: "BWA",
    name: "بوتسوانا",
  },
  {
    code: "BVT",
    name: "جزيرة بوفيت",
  },
  {
    code: "BRA",
    name: "البرازيل",
  },
  {
    code: "IOT",
    name: "المقاطعة البريطانية في المحيط الهندي",
  },
  {
    code: "BRN",
    name: "بروناى",
  },
  {
    code: "BGR",
    name: "بلغاريا",
  },
  {
    code: "BFA",
    name: "بوركينا",
  },
  {
    code: "BDI",
    name: "بوروندى",
  },
  {
    code: "KHM",
    name: "كامبوديا",
  },
  {
    code: "CMR",
    name: "الكاميرون",
  },
  {
    code: "CAN",
    name: "كندا",
  },
  {
    code: "CPV",
    name: "كاب فيرد",
  },
  {
    code: "CYM",
    name: "جزر كايمان",
  },
  {
    code: "CAF",
    name: "جمهورية وسط أفريقيا",
  },
  {
    code: "TCD",
    name: "تشاد",
  },
  {
    code: "CHL",
    name: "تشيلي",
  },
  {
    code: "CHN",
    name: "الصين",
  },
  {
    code: "CXR",
    name: "جزيرة كريسماس",
  },
  {
    code: "CCK",
    name: "جزر كوكوس",
  },
  {
    code: "COL",
    name: "كولومبيا",
  },
  {
    code: "COM",
    name: "جزر القمر",
  },
  {
    code: "COG",
    name: "الكنغو",
  },
  {
    code: "COK",
    name: "جزر كوك",
  },
  {
    code: "CRI",
    name: "كوستاريكا",
  },
  {
    code: "CIV",
    name: "كوت دي فوار",
  },
  {
    code: "HRV",
    name: "كرواتيا",
  },
  {
    code: "CUB",
    name: "كوبا",
  },
  {
    code: "CYP",
    name: "قبرص",
  },
  {
    code: "CZE",
    name: "جمهورية التشيك",
  },
  {
    code: "DNK",
    name: "الدنمارك",
  },
  {
    code: "DJI",
    name: "جيبوتى",
  },
  {
    code: "DMA",
    name: "الدمنيكان",
  },
  {
    code: "DOM",
    name: "جمهورية الدمنيكان",
  },
  {
    code: "TMP",
    name: "شرق تيمور",
  },
  {
    code: "ECU",
    name: "الاكوادور",
  },
  {
    code: "EGY",
    name: "مصر",
  },
  {
    code: "SLV",
    name: "السلفادور",
  },
  {
    code: "GNQ",
    name: "غينيا الأستوائية",
  },
  {
    code: "ERI",
    name: "أريتيريا",
  },
  {
    code: "EST",
    name: "استونيا",
  },
  {
    code: "ETH",
    name: "إثيوبيــــا",
  },
  {
    code: "FLK",
    name: "جزر - فوكلاند",
  },
  {
    code: "FRO",
    name: "جزر فاروه",
  },
  {
    code: "FJI",
    name: "فيجــــــى",
  },
  {
    code: "FIN",
    name: "فنلاندا",
  },
  {
    code: "FRA",
    name: "فرنسا",
  },
  {
    code: "FXX",
    name: "ميتروبوليتان الفرنسية",
  },
  {
    code: "GUF",
    name: "جوانا الفرنسية",
  },
  {
    code: "PYF",
    name: "بولينيزيا الفرنسية",
  },
  {
    code: "ATF",
    name: "فرنسا الجنوبية والقطبية",
  },
  {
    code: "GAB",
    name: "الجابون",
  },
  {
    code: "GMB",
    name: "جامبيا",
  },
  {
    code: "GEO",
    name: "جورجيا",
  },
  {
    code: "DEU",
    name: "ألمانيا",
  },
  {
    code: "GHA",
    name: "غانـا",
  },
  {
    code: "GIB",
    name: "جبل طــــارق",
  },
  {
    code: "GRC",
    name: "اليونان",
  },
  {
    code: "GRL",
    name: "جرين لاند",
  },
  {
    code: "GRD",
    name: "جرينادا",
  },
  {
    code: "GLP",
    name: "جواد يلوب",
  },
  {
    code: "GUM",
    name: "جوام",
  },
  {
    code: "GTM",
    name: "جواتيمالا",
  },
  {
    code: "GIN",
    name: "غينيا",
  },
  {
    code: "GNB",
    name: "غينيا بيساو",
  },
  {
    code: "GUY",
    name: "جويانا",
  },
  {
    code: "HTI",
    name: "هايتى",
  },
  {
    code: "HMD",
    name: "جزيرة هيرد وجزيرة ماكدونالد",
  },
  {
    code: "HND",
    name: "هندوراس",
  },
  {
    code: "HUN",
    name: "المجر",
  },
  {
    code: "ISL",
    name: "ايسلاندا",
  },
  {
    code: "IND",
    name: "الهند",
  },
  {
    code: "IDN",
    name: "إندونسيا",
  },
  {
    code: "IRN",
    name: "ايران",
  },
  {
    code: "IRQ",
    name: "العراق",
  },
  {
    code: "IRL",
    name: "ايرلاندا",
  },
  {
    code: "ITA",
    name: "ايطاليا",
  },
  {
    code: "JAM",
    name: "جامايكا",
  },
  {
    code: "JPN",
    name: "اليابان",
  },
  {
    code: "JOR",
    name: "الاردن",
  },
  {
    code: "KAZ",
    name: "كاذاخستان",
  },
  {
    code: "KEN",
    name: "كينيا",
  },
  {
    code: "KIR",
    name: "كيريباتيا",
  },
  {
    code: "KOR",
    name: "كوريا الجنــوبية",
  },
  {
    code: "PRK",
    name: "كوريا الشمالية",
  },
  {
    code: "RKS",
    name: "كوسوفا",
  },
  {
    code: "LAO",
    name: "لاوس",
  },
  {
    code: "LVA",
    name: "لاتفيا",
  },
  {
    code: "LBN",
    name: "لبنان",
  },
  {
    code: "LSO",
    name: "ليسوتو",
  },
  {
    code: "LBR",
    name: "ليبيريا",
  },
  {
    code: "LBY",
    name: "ليبيا",
  },
  {
    code: "LIE",
    name: "ليختشتاين",
  },
  {
    code: "LTU",
    name: "لتوانيا",
  },
  {
    code: "LUX",
    name: "لوكسمبورج",
  },
  {
    code: "MAC",
    name: "ماكاو",
  },
  {
    code: "MKD",
    name: "ماكيدونيا",
  },
  {
    code: "MDG",
    name: "مدغـشقر",
  },
  {
    code: "MWI",
    name: "مالاوى",
  },
  {
    code: "MYS",
    name: "ماليزيا",
  },
  {
    code: "MDV",
    name: "المالديف",
  },
  {
    code: "MLI",
    name: "مالى",
  },
  {
    code: "MLT",
    name: "مالطا",
  },
  {
    code: "MHN",
    name: "جزر مارشال",
  },
  {
    code: "MHL",
    name: "جزر مارشال",
  },
  {
    code: "MTQ",
    name: "المارتينك",
  },
  {
    code: "MRT",
    name: "موريتانيا",
  },
  {
    code: "MUS",
    name: "موريشيوس",
  },
  {
    code: "MYT",
    name: "مايوت",
  },
  {
    code: "MEX",
    name: "المكسيك‏",
  },
  {
    code: "FSM",
    name: "ولاية مكرونسيا الأتحادية",
  },
  {
    code: "MSF",
    name: "ولاية مكرونسيا الأتحادية",
  },
  {
    code: "MCO",
    name: "موناكو",
  },
  {
    code: "MNG",
    name: "منغوليا",
  },
  {
    code: "MSR",
    name: "مونتسرات",
  },
  {
    code: "MAR",
    name: "المغرب",
  },
  {
    code: "MOZ",
    name: "موزمبيق",
  },
  {
    code: "MMR",
    name: "مينمار",
  },
  {
    code: "NAM",
    name: "نامبيا",
  },
  {
    code: "NRU",
    name: "ناورو",
  },
  {
    code: "NPL",
    name: "نيبال",
  },
  {
    code: "NLD",
    name: "هولندا",
  },
  {
    code: "ANT",
    name: "انتيل الهولندية",
  },
  {
    code: "NCL",
    name: "نيو - كاليدونيا",
  },
  {
    code: "NZL",
    name: "نيوزيلاند",
  },
  {
    code: "NIC",
    name: "نيكاراجوا",
  },
  {
    code: "NER",
    name: "النيجر",
  },
  {
    code: "NGA",
    name: "نيجيريا",
  },
  {
    code: "NIU",
    name: "نيوى جزر",
  },
  {
    code: "NBH",
    name: "غير بحريني",
  },
  {
    code: "NEM",
    name: "غير اماراتي",
  },
  {
    code: "NKW",
    name: "غير كويتي",
  },
  {
    code: "NOM",
    name: "غير عماني",
  },
  {
    code: "NQT",
    name: "غير قطري",
  },
  {
    code: "NFK",
    name: "جزيرة نورفولك",
  },
  {
    code: "MNP",
    name: "جزر ماريانا الشمالية",
  },
  {
    code: "NOR",
    name: "النرويج",
  },
  {
    code: "PAK",
    name: "باكستان",
  },
  {
    code: "PLW",
    name: "بالو",
  },
  {
    code: "PSE",
    name: "فلسطين",
  },
  {
    code: "PAN",
    name: "بنما",
  },
  {
    code: "PNG",
    name: "بابوا - نيو - جونييا",
  },
  {
    code: "PRY",
    name: "باراجواى",
  },
  {
    code: "PER",
    name: "بيرو",
  },
  {
    code: "PHL",
    name: "الفلبين",
  },
  {
    code: "PCN",
    name: "جزر بيتكايرن",
  },
  {
    code: "POL",
    name: "بولندا",
  },
  {
    code: "PRT",
    name: "البرتغال",
  },
  {
    code: "PRI",
    name: "بورتوريكو",
  },
  {
    code: "MDA",
    name: "جمهورية مالدوفا",
  },
  {
    code: "REU",
    name: "رينو",
  },
  {
    code: "ROM",
    name: "رومانيا",
  },
  {
    code: "RUS",
    name: "روسيا الإتحادية",
  },
  {
    code: "RWA",
    name: "روانــــــــــدا",
  },
  {
    code: "KNA",
    name: "سانت كيتس و نافيس",
  },
  {
    code: "LCA",
    name: "ســانت لوتشــيا",
  },
  {
    code: "SPM",
    name: "سانت بيير و ميجولين",
  },
  {
    code: "VCT",
    name: "سانت فينسنت و جرينادين",
  },
  {
    code: "WSM",
    name: "ساموا",
  },
  {
    code: "SMR",
    name: "سان مارينو",
  },
  {
    code: "STP",
    name: "ساو - توم - وبرنسيب",
  },
  {
    code: "SEN",
    name: "السنغال",
  },
  {
    code: "SCG",
    name: "صربيا والجبل الاسود",
  },
  {
    code: "SYC",
    name: "سيشل",
  },
  {
    code: "SLE",
    name: "سيراليون",
  },
  {
    code: "SGP",
    name: "سنغافورة",
  },
  {
    code: "SVK",
    name: "جمهورية سلوفاكيا",
  },
  {
    code: "SVN",
    name: "سلوفينيا",
  },
  {
    code: "SLB",
    name: "جزر سليمــــان",
  },
  {
    code: "SOM",
    name: "الصومال",
  },
  {
    code: "ZAF",
    name: "جنوب أفريقيا",
  },
  {
    code: "SGS",
    name: "جنوب جورجيا",
  },
  {
    code: "ESP",
    name: "أسبانيا",
  },
  {
    code: "LKA",
    name: "سريلانكا",
  },
  {
    code: "SHN",
    name: "هيلينا",
  },
  {
    code: "SDN",
    name: "السودان",
  },
  {
    code: "SUR",
    name: "سورينام",
  },
  {
    code: "SJM",
    name: "سفلبارد",
  },
  {
    code: "SWZ",
    name: "سوازيـلانـــــــــد",
  },
  {
    code: "SWE",
    name: "السويد",
  },
  {
    code: "CHE",
    name: "سويسرا",
  },
  {
    code: "SYR",
    name: "سوريا",
  },
  {
    code: "TWN",
    name: "تايوان",
  },
  {
    code: "TJK",
    name: "طاجكستان",
  },
  {
    code: "THA",
    name: "تايلاند",
  },
  {
    code: "TGO",
    name: "توجو",
  },
  {
    code: "TKL",
    name: "توكيلاو",
  },
  {
    code: "TON",
    name: "تونجــا",
  },
  {
    code: "TTO",
    name: "ترينيداد وتوباجو",
  },
  {
    code: "TUN",
    name: "تونس",
  },
  {
    code: "TUR",
    name: "تركيا",
  },
  {
    code: "TKM",
    name: "تركمنستان",
  },
  {
    code: "TCA",
    name: "جزر تركس وكايكوس",
  },
  {
    code: "TUV",
    name: "توفالــــــــو",
  },
  {
    code: "UGA",
    name: "أوغندا",
  },
  {
    code: "UKR",
    name: "اكرانيا",
  },
  {
    code: "GBR",
    name: "المملكة المتحدة",
  },
  {
    code: "USA",
    name: "الولايات المتحدة الامريكية",
  },
  {
    code: "UMI",
    name: "جزر مينور",
  },
  {
    code: "TZA",
    name: "تنزانيا",
  },
  {
    code: "URY",
    name: "أورجواى",
  },
  {
    code: "UZB",
    name: "اوزبكستان",
  },
  {
    code: "VUT",
    name: "فانواتو",
  },
  {
    code: "VAT",
    name: "الفاتيكان",
  },
  {
    code: "VEN",
    name: "فنزويلا",
  },
  {
    code: "VNM",
    name: "فييتنام",
  },
  {
    code: "VGB",
    name: "جزر فرجين",
  },
  {
    code: "VIR",
    name: "جزر فيرجينيا",
  },
  {
    code: "WLF",
    name: "واليز فوتونا",
  },
  {
    code: "YEM",
    name: "اليمن",
  },
  {
    code: "YUG",
    name: "يوغسلافيا",
  },
  {
    code: "ZAR",
    name: "زائيـــــــر",
  },
  {
    code: "ZMB",
    name: "زامبيا",
  },
  {
    code: "ZWE",
    name: "زيمبابوى",
  },
  {
    code: "KGZ",
    name: "قرغيزستان",
  },
];

export const nationalityCodeListEn = [
  {
    code: "AFG",
    name: "Afghanistan",
  },
  {
    code: "ALB",
    name: "Albania",
  },
  {
    code: "DZA",
    name: "Algeria",
  },
  {
    code: "ASM",
    name: "American Samoa",
  },
  {
    code: "AND",
    name: "Andorra",
  },
  {
    code: "AGO",
    name: "Angola",
  },
  {
    code: "AIA",
    name: "Anguilla",
  },
  {
    code: "ATA",
    name: "Antarctic",
  },
  {
    code: "ATG",
    name: "Antigua",
  },
  {
    code: "ARG",
    name: "Argentina",
  },
  {
    code: "ARM",
    name: "Armenia",
  },
  {
    code: "ABW",
    name: "Aruba",
  },
  {
    code: "AUS",
    name: "Australia",
  },
  {
    code: "AUT",
    name: "Austria",
  },
  {
    code: "AZE",
    name: "Azerbaijan",
  },
  {
    code: "BHS",
    name: "Bahamas",
  },
  {
    code: "BGD",
    name: "Bangladesh",
  },
  {
    code: "BRB",
    name: "Barbados",
  },
  {
    code: "BLR",
    name: "Belarus",
  },
  {
    code: "BEL",
    name: "Belgium",
  },
  {
    code: "BLZ",
    name: "Belize",
  },
  {
    code: "BEN",
    name: "Benin",
  },
  {
    code: "BMU",
    name: "Bermuda",
  },
  {
    code: "BTN",
    name: "Bhutan",
  },
  {
    code: "BOL",
    name: "Bolivia",
  },
  {
    code: "BIH",
    name: "Bosnia",
  },
  {
    code: "BWA",
    name: "Botswana",
  },
  {
    code: "BVT",
    name: "Bouvet Island",
  },
  {
    code: "BRA",
    name: "Brazil",
  },
  {
    code: "IOT",
    name: "British Indian Ocean Territory",
  },
  {
    code: "BRN",
    name: "Brunei",
  },
  {
    code: "BGR",
    name: "Bulgaria",
  },
  {
    code: "BFA",
    name: "Burkina Faso",
  },
  {
    code: "BDI",
    name: "Burundi",
  },
  {
    code: "KHM",
    name: "Cambodia",
  },
  {
    code: "CMR",
    name: "Cameroon",
  },
  {
    code: "CAN",
    name: "Canada",
  },
  {
    code: "CPV",
    name: "Cape Verde",
  },
  {
    code: "CYM",
    name: "Cayman Island",
  },
  {
    code: "CAF",
    name: "Central African Republic",
  },
  {
    code: "TCD",
    name: "Chad",
  },
  {
    code: "CHL",
    name: "Chile",
  },
  {
    code: "CHN",
    name: "China",
  },
  {
    code: "CXR",
    name: "Christmas Island",
  },
  {
    code: "CCK",
    name: "Cocos Island",
  },
  {
    code: "COL",
    name: "Colombia",
  },
  {
    code: "COM",
    name: "Comoros",
  },
  {
    code: "COG",
    name: "Congo",
  },
  {
    code: "COK",
    name: "Cook Island",
  },
  {
    code: "CRI",
    name: "Costa Rica",
  },
  {
    code: "CIV",
    name: "Cote Divoire",
  },
  {
    code: "HRV",
    name: "Croatia",
  },
  {
    code: "CUB",
    name: "Cuba",
  },
  {
    code: "CYP",
    name: "Cyprus",
  },
  {
    code: "CZE",
    name: "Czech Republic",
  },
  {
    code: "DNK",
    name: "Denmark",
  },
  {
    code: "DJI",
    name: "Djibouti",
  },
  {
    code: "DMA",
    name: "Dominica",
  },
  {
    code: "DOM",
    name: "Dominican Republic",
  },
  {
    code: "TMP",
    name: "East Timor",
  },
  {
    code: "ECU",
    name: "Ecuador",
  },
  {
    code: "EGY",
    name: "Egypt",
  },
  {
    code: "SLV",
    name: "El Salvador",
  },
  {
    code: "GNQ",
    name: "Equatorial  Guinea",
  },
  {
    code: "ERI",
    name: "Eritrea",
  },
  {
    code: "EST",
    name: "Estonia",
  },
  {
    code: "ETH",
    name: "Ethiopia",
  },
  {
    code: "FLK",
    name: "Falkland Islands",
  },
  {
    code: "FRO",
    name: "Faroe Islands",
  },
  {
    code: "FJI",
    name: "Fiji",
  },
  {
    code: "FIN",
    name: "Finland",
  },
  {
    code: "FRA",
    name: "France",
  },
  {
    code: "FXX",
    name: "France, Metropolitan",
  },
  {
    code: "GUF",
    name: "French Guiana",
  },
  {
    code: "PYF",
    name: "French Polynesia",
  },
  {
    code: "ATF",
    name: "French Southern and Antarctic",
  },
  {
    code: "GAB",
    name: "Gabon",
  },
  {
    code: "GMB",
    name: "Gambia",
  },
  {
    code: "GEO",
    name: "Georgia",
  },
  {
    code: "DEU",
    name: "Germany",
  },
  {
    code: "GHA",
    name: "Ghana",
  },
  {
    code: "GIB",
    name: "Gibraltar",
  },
  {
    code: "GRC",
    name: "Greece",
  },
  {
    code: "GRL",
    name: "Greenland",
  },
  {
    code: "GRD",
    name: "Grenada",
  },
  {
    code: "GLP",
    name: "Guadeloupe",
  },
  {
    code: "GUM",
    name: "Guam",
  },
  {
    code: "GTM",
    name: "Guatemala",
  },
  {
    code: "GIN",
    name: "Guinea",
  },
  {
    code: "GNB",
    name: "Guinea-Bissau",
  },
  {
    code: "GUY",
    name: "Guyana",
  },
  {
    code: "HTI",
    name: "Haiti",
  },
  {
    code: "HMD",
    name: "Heard Island and McDonald Island",
  },
  {
    code: "HND",
    name: "Honduras",
  },
  {
    code: "HUN",
    name: "Hungary",
  },
  {
    code: "ISL",
    name: "Iceland",
  },
  {
    code: "IND",
    name: "India",
  },
  {
    code: "IDN",
    name: "Indonesia",
  },
  {
    code: "IRN",
    name: "Iran",
  },
  {
    code: "IRQ",
    name: "Iraq",
  },
  {
    code: "IRL",
    name: "Ireland",
  },
  {
    code: "ITA",
    name: "Italy",
  },
  {
    code: "JAM",
    name: "Jamaica",
  },
  {
    code: "JPN",
    name: "Japan",
  },
  {
    code: "JOR",
    name: "Jordan",
  },
  {
    code: "KAZ",
    name: "Kazakhstan",
  },
  {
    code: "KEN",
    name: "Kenya",
  },
  {
    code: "KIR",
    name: "Kiribati",
  },
  {
    code: "KOR",
    name: "Korea , South",
  },
  {
    code: "PRK",
    name: "Korea, North",
  },
  {
    code: "RKS",
    name: "Kosovo",
  },
  {
    code: "LAO",
    name: "Laos",
  },
  {
    code: "LVA",
    name: "Latvia",
  },
  {
    code: "LBN",
    name: "Lebanon",
  },
  {
    code: "LSO",
    name: "Lesotho",
  },
  {
    code: "LBR",
    name: "Liberia",
  },
  {
    code: "LBY",
    name: "Libya",
  },
  {
    code: "LIE",
    name: "Liechtenstein",
  },
  {
    code: "LTU",
    name: "Lithuania",
  },
  {
    code: "LUX",
    name: "Luxembourg",
  },
  {
    code: "MAC",
    name: "Macau",
  },
  {
    code: "MKD",
    name: "Macedonia, The Former Yugoslav Republic of",
  },
  {
    code: "MDG",
    name: "Madagascar",
  },
  {
    code: "MWI",
    name: "Malawi",
  },
  {
    code: "MYS",
    name: "Malaysia",
  },
  {
    code: "MDV",
    name: "Maldives",
  },
  {
    code: "MLI",
    name: "Mali",
  },
  {
    code: "MLT",
    name: "Malta",
  },
  {
    code: "MHN",
    name: "Marshall Island",
  },
  {
    code: "MHL",
    name: "Marshall Islands",
  },
  {
    code: "MTQ",
    name: "Martinique",
  },
  {
    code: "MRT",
    name: "Mauritania",
  },
  {
    code: "MUS",
    name: "Mauritius",
  },
  {
    code: "MYT",
    name: "Mayotte",
  },
  {
    code: "MEX",
    name: "Mexico",
  },
  {
    code: "FSM",
    name: "Micronesia , Federated Stat",
  },
  {
    code: "MSF",
    name: "Micronesia , Federated Stat",
  },
  {
    code: "MCO",
    name: "Monaco",
  },
  {
    code: "MNG",
    name: "Mongolia",
  },
  {
    code: "MSR",
    name: "Montserrat",
  },
  {
    code: "MAR",
    name: "Morocco",
  },
  {
    code: "MOZ",
    name: "Mozambique",
  },
  {
    code: "MMR",
    name: "Myanmar",
  },
  {
    code: "NAM",
    name: "Namibia",
  },
  {
    code: "NRU",
    name: "Nauru",
  },
  {
    code: "NPL",
    name: "Nepal",
  },
  {
    code: "NLD",
    name: "Netherlands",
  },
  {
    code: "ANT",
    name: "Netherlands Antilles",
  },
  {
    code: "NCL",
    name: "New Caledonia",
  },
  {
    code: "NZL",
    name: "New Zealand",
  },
  {
    code: "NIC",
    name: "Nicaragua",
  },
  {
    code: "NER",
    name: "Niger",
  },
  {
    code: "NGA",
    name: "Nigeria",
  },
  {
    code: "NIU",
    name: "Niue",
  },
  {
    code: "NBH",
    name: "Non-Bahraini",
  },
  {
    code: "NEM",
    name: "Non-Emirati",
  },
  {
    code: "NKW",
    name: "Non-Kuwaiti",
  },
  {
    code: "NOM",
    name: "Non-Omani",
  },
  {
    code: "NQT",
    name: "Non-Qatari",
  },
  {
    code: "NFK",
    name: "Norfolk Island",
  },
  {
    code: "MNP",
    name: "Northern Mariana Islands",
  },
  {
    code: "NOR",
    name: "Norway",
  },
  {
    code: "PAK",
    name: "Pakistan",
  },
  {
    code: "PLW",
    name: "Palau",
  },
  {
    code: "PSE",
    name: "Palestinian Territory, Occupied",
  },
  {
    code: "PAN",
    name: "Panama",
  },
  {
    code: "PNG",
    name: "Papua New Guinea",
  },
  {
    code: "PRY",
    name: "Paraguay",
  },
  {
    code: "PER",
    name: "Peru",
  },
  {
    code: "PHL",
    name: "Philippines",
  },
  {
    code: "PCN",
    name: "Pitcairn Islands",
  },
  {
    code: "POL",
    name: "Poland",
  },
  {
    code: "PRT",
    name: "Portugal",
  },
  {
    code: "PRI",
    name: "Puerto Rico",
  },
  {
    code: "MDA",
    name: "Republic of Moldova",
  },
  {
    code: "REU",
    name: "Reunion",
  },
  {
    code: "ROM",
    name: "Romania",
  },
  {
    code: "RUS",
    name: "Russian Federation",
  },
  {
    code: "RWA",
    name: "Rwanda",
  },
  {
    code: "KNA",
    name: "Saint Kitts and Nevis",
  },
  {
    code: "LCA",
    name: "Saint Lucia",
  },
  {
    code: "SPM",
    name: "Saint Pierre and Miquelon",
  },
  {
    code: "VCT",
    name: "Saint Vincent and  the Grenadines",
  },
  {
    code: "WSM",
    name: "Samoa",
  },
  {
    code: "SMR",
    name: "San Marino",
  },
  {
    code: "STP",
    name: "Sao Tome And Principe",
  },
  {
    code: "SEN",
    name: "Senegal",
  },
  {
    code: "SCG",
    name: "Serbia and Montenegro",
  },
  {
    code: "SYC",
    name: "Seychelles",
  },
  {
    code: "SLE",
    name: "Sierra Leone",
  },
  {
    code: "SGP",
    name: "Singapore",
  },
  {
    code: "SVK",
    name: "Slovak Republic",
  },
  {
    code: "SVN",
    name: "Slovenia",
  },
  {
    code: "SLB",
    name: "Solomon Islands",
  },
  {
    code: "SOM",
    name: "Somalia",
  },
  {
    code: "ZAF",
    name: "South Africa",
  },
  {
    code: "SGS",
    name: "South Georgia and The South",
  },
  {
    code: "ESP",
    name: "Spain",
  },
  {
    code: "LKA",
    name: "Sri Lanka",
  },
  {
    code: "SHN",
    name: "ST. Helena",
  },
  {
    code: "SDN",
    name: "Sudan",
  },
  {
    code: "SUR",
    name: "Suriname",
  },
  {
    code: "SJM",
    name: "Svalbard",
  },
  {
    code: "SWZ",
    name: "Swaziland",
  },
  {
    code: "SWE",
    name: "Sweden",
  },
  {
    code: "CHE",
    name: "Switzerland",
  },
  {
    code: "SYR",
    name: "Syrian",
  },
  {
    code: "TWN",
    name: "Taiwan",
  },
  {
    code: "TJK",
    name: "Tajikistan",
  },
  {
    code: "THA",
    name: "Thailand",
  },
  {
    code: "TGO",
    name: "Togo",
  },
  {
    code: "TKL",
    name: "Tokelau",
  },
  {
    code: "TON",
    name: "Tonga",
  },
  {
    code: "TTO",
    name: "Trinidad and Tobago",
  },
  {
    code: "TUN",
    name: "Tunisia",
  },
  {
    code: "TUR",
    name: "Turkey",
  },
  {
    code: "TKM",
    name: "Turkmenistan",
  },
  {
    code: "TCA",
    name: "Turks and Caicos Islands",
  },
  {
    code: "TUV",
    name: "Tuvalu",
  },
  {
    code: "UGA",
    name: "Uganda",
  },
  {
    code: "UKR",
    name: "Ukraine",
  },
  {
    code: "GBR",
    name: "United Kingdom",
  },
  {
    code: "USA",
    name: "United States",
  },
  {
    code: "UMI",
    name: "United States Minor Outlying Islands",
  },
  {
    code: "TZA",
    name: "UR Tanzania",
  },
  {
    code: "URY",
    name: "Uruguay",
  },
  {
    code: "UZB",
    name: "Uzbekistan",
  },
  {
    code: "VUT",
    name: "Vanuatu",
  },
  {
    code: "VAT",
    name: "Vatican City State",
  },
  {
    code: "VEN",
    name: "Venezuela",
  },
  {
    code: "VNM",
    name: "Vietnam",
  },
  {
    code: "VGB",
    name: "Virgin Islands",
  },
  {
    code: "VIR",
    name: "Virgin Islands(U.S.)",
  },
  {
    code: "WLF",
    name: "Wallis and Futuna",
  },
  {
    code: "YEM",
    name: "Yemen",
  },
  {
    code: "YUG",
    name: "Yugoslavia",
  },
  {
    code: "ZAR",
    name: "Zaire",
  },
  {
    code: "ZMB",
    name: "Zambia",
  },
  {
    code: "ZWE",
    name: "Zimbabwe",
  },
  {
    code: "KGZ",
    name: "KYRGYZSTAN",
  },
];

export const placeofbirthList = [
  {
    code: "0",
    descriptionAr: "منطقة الرياض",
    descriptionEn: "Riyadh",
  },
  {
    code: "99",
    descriptionAr: "أخرى",
    descriptionEn: "Other",
  },
  {
    code: "20",
    descriptionAr: "أبها",
    descriptionEn: "ABHA",
  },
  {
    code: "238",
    descriptionAr: "بقيق",
    descriptionEn: "ABQAIQ",
  },
  {
    code: "929",
    descriptionAr: "أبوظبي",
    descriptionEn: "ABU DHABI",
  },
  {
    code: "1007",
    descriptionAr: "الدوادمي",
    descriptionEn: "ADDAWADMI",
  },
  {
    code: "143",
    descriptionAr: "أفغانستان",
    descriptionEn: "AFGHANISTAN",
  },
  {
    code: "278",
    descriptionAr: "عفيف",
    descriptionEn: "AFIF",
  },
  {
    code: "1014",
    descriptionAr: "عفيف",
    descriptionEn: "AFIF",
  },
  {
    code: "1009",
    descriptionAr: "عين دار",
    descriptionEn: "AIN DAR",
  },
  {
    code: "233",
    descriptionAr: "الأفلاج",
    descriptionEn: "AL AFLAJ",
  },
  {
    code: "17",
    descriptionAr: "الأحساء",
    descriptionEn: "AL AHSA",
  },
  {
    code: "264",
    descriptionAr: "البادي",
    descriptionEn: "AL BADI",
  },
  {
    code: "35",
    descriptionAr: "الباحة",
    descriptionEn: "AL BAHA",
  },
  {
    code: "251",
    descriptionAr: "البكيرية",
    descriptionEn: "AL BUKAYRIYAH",
  },
  {
    code: "1026",
    descriptionAr: "الدلم",
    descriptionEn: "AL DALAM",
  },
  {
    code: "1003",
    descriptionAr: "الدرب",
    descriptionEn: "AL DARB",
  },
  {
    code: "1027",
    descriptionAr: "الغولة",
    descriptionEn: "AL GHOWLAH",
  },
  {
    code: "265",
    descriptionAr: "الحديث",
    descriptionEn: "AL HADITHA",
  },
  {
    code: "244",
    descriptionAr: "الحراك",
    descriptionEn: "AL HARIQ",
  },
  {
    code: "300",
    descriptionAr: "الجوف",
    descriptionEn: "AL JOUF",
  },
  {
    code: "4",
    descriptionAr: "الجبيل",
    descriptionEn: "AL JUBAIL",
  },
  {
    code: "30",
    descriptionAr: "الخفجي",
    descriptionEn: "AL KHAFJI",
  },
  {
    code: "38",
    descriptionAr: "منطقة الرياض",
    descriptionEn: "Riyadh",
  },
  {
    code: "5",
    descriptionAr: "الخرج",
    descriptionEn: "AL KHARJ",
  },
  {
    code: "29",
    descriptionAr: "الخبر",
    descriptionEn: "AL KHOBAR",
  },
  {
    code: "1036",
    descriptionAr: "الخرخير",
    descriptionEn: "AL Kharkheer",
  },
  {
    code: "6",
    descriptionAr: "المدينة المنورة",
    descriptionEn: "AL MADINAH",
  },
  {
    code: "1044",
    descriptionAr: "المدينة المنورة",
    descriptionEn: "AL MADINAH, ANABS DIST.",
  },
  {
    code: "1045",
    descriptionAr: "المدينة المنورة",
    descriptionEn: "AL MADINAH, ANABS DIST.",
  },
  {
    code: "1031",
    descriptionAr: "المجمعة",
    descriptionEn: "AL MAJMAAH",
  },
  {
    code: "252",
    descriptionAr: "المدناب",
    descriptionEn: "AL MIDNAB",
  },
  {
    code: "1051",
    descriptionAr: "المبرز",
    descriptionEn: "AL MUBARAZ",
  },
  {
    code: "1008",
    descriptionAr: "النماص",
    descriptionEn: "AL NAMAS",
  },
  {
    code: "31",
    descriptionAr: "القطيف",
    descriptionEn: "AL QATIF",
  },
  {
    code: "282",
    descriptionAr: "القيصومة",
    descriptionEn: "AL QAYSUMAH",
  },
  {
    code: "254",
    descriptionAr: "القنفذة",
    descriptionEn: "AL QUNFUTHAH",
  },
  {
    code: "39",
    descriptionAr: "القريات",
    descriptionEn: "AL QURAYAT",
  },
  {
    code: "1025",
    descriptionAr: "الرقعي",
    descriptionEn: "AL RUQAI",
  },
  {
    code: "253",
    descriptionAr: "الشماسية",
    descriptionEn: "AL SHAMMASIYAH",
  },
  {
    code: "13",
    descriptionAr: "الطائف",
    descriptionEn: "AL TAIF",
  },
  {
    code: "225",
    descriptionAr: "الوديعة",
    descriptionEn: "AL WADIAAH",
  },
  {
    code: "266",
    descriptionAr: "الوجه",
    descriptionEn: "AL WAJH",
  },
  {
    code: "1057",
    descriptionAr: "القيعية",
    descriptionEn: "AL-GUAEYIA .",
  },
  {
    code: "1050",
    descriptionAr: "الحفوف",
    descriptionEn: "AL-HAFOUF",
  },
  {
    code: "1054",
    descriptionAr: "الليث",
    descriptionEn: "AL-LEETH",
  },
  {
    code: "1053",
    descriptionAr: "المخواة",
    descriptionEn: "AL-MAKHWAH",
  },
  {
    code: "1060",
    descriptionAr: "المزناب",
    descriptionEn: "AL-MAZNAB",
  },
  {
    code: "1034",
    descriptionAr: "الربيع",
    descriptionEn: "AL-RABIA RIYADH",
  },
  {
    code: "1049",
    descriptionAr: "السليل",
    descriptionEn: "AL-SILAYEL",
  },
  {
    code: "275",
    descriptionAr: "العلا",
    descriptionEn: "AL-ULA",
  },
  {
    code: "1072",
    descriptionAr: "العلا",
    descriptionEn: "AL-ULAA",
  },
  {
    code: "110",
    descriptionAr: "ألبانيا",
    descriptionEn: "ALBANIA",
  },
  {
    code: "49",
    descriptionAr: "الجزائر",
    descriptionEn: "ALGERIA",
  },
  {
    code: "1079",
    descriptionAr: "الجموم",
    descriptionEn: "ALJUMOUM",
  },
  {
    code: "1062",
    descriptionAr: "المندق",
    descriptionEn: "ALMNDAQ",
  },
  {
    code: "1075",
    descriptionAr: "القويعية",
    descriptionEn: "ALQUWAY'IYAH",
  },
  {
    code: "111",
    descriptionAr: "أندورا",
    descriptionEn: "ANDORRA",
  },
  {
    code: "63",
    descriptionAr: "أنغولا",
    descriptionEn: "ANGOLA",
  },
  {
    code: "178",
    descriptionAr: "أنغيلا",
    descriptionEn: "ANGUILLA",
  },
  {
    code: "21",
    descriptionAr: "أنيرية",
    descriptionEn: "ANNAIRIYAH",
  },
  {
    code: "179",
    descriptionAr: "القديمة",
    descriptionEn: "ANTIGUA",
  },
  {
    code: "256",
    descriptionAr: "العقبة",
    descriptionEn: "AQABAT",
  },
  {
    code: "250",
    descriptionAr: "الخليج العربي",
    descriptionEn: "ARABIAN GULF",
  },
  {
    code: "24",
    descriptionAr: "المحراث",
    descriptionEn: "ARAR",
  },
  {
    code: "208",
    descriptionAr: "الأرجنتين",
    descriptionEn: "ARGENTINA",
  },
  {
    code: "27",
    descriptionAr: "أراغاي",
    descriptionEn: "ARRAGAI",
  },
  {
    code: "258",
    descriptionAr: "العرش",
    descriptionEn: "ARRASS",
  },
  {
    code: "232",
    descriptionAr: "أرطاوية",
    descriptionEn: "ARTAWIYAH",
  },
  {
    code: "180",
    descriptionAr: "أروبا",
    descriptionEn: "ARUBA",
  },
  {
    code: "1012",
    descriptionAr: "منطقة عسير",
    descriptionEn: "ASEER AREA",
  },
  {
    code: "1013",
    descriptionAr: "أسلاييل",
    descriptionEn: "ASULAYYIL",
  },
  {
    code: "219",
    descriptionAr: "أستراليا",
    descriptionEn: "AUSTRALIA",
  },
  {
    code: "112",
    descriptionAr: "أستراليا",
    descriptionEn: "AUSTRIA",
  },
  {
    code: "245",
    descriptionAr: "أزيلفي",
    descriptionEn: "AZZILFI",
  },
  {
    code: "1055",
    descriptionAr: "الحصي",
    descriptionEn: "Al-Hissi",
  },
  {
    code: "181",
    descriptionAr: "جزر البهاما",
    descriptionEn: "BAHAMAS",
  },
  {
    code: "224",
    descriptionAr: "بحرة",
    descriptionEn: "BAHRAH",
  },
  {
    code: "44",
    descriptionAr: "البحرين",
    descriptionEn: "BAHRAIN",
  },
  {
    code: "1041",
    descriptionAr: "بلجرشي",
    descriptionEn: "BALJURASHI",
  },
  {
    code: "226",
    descriptionAr: "بالاسمار",
    descriptionEn: "BALLASMAR",
  },
  {
    code: "144",
    descriptionAr: "بنغلاديش",
    descriptionEn: "BANGLADESH",
  },
  {
    code: "182",
    descriptionAr: "بربادوس",
    descriptionEn: "BARBADOS",
  },
  {
    code: "1074",
    descriptionAr: "شاطئ فى منظقة جازان",
    descriptionEn: "BEECH, IN JAZAN AREA",
  },
  {
    code: "1023",
    descriptionAr: "بيشة",
    descriptionEn: "BEISHA",
  },
  {
    code: "113",
    descriptionAr: "بلجيكا",
    descriptionEn: "BELGIUM",
  },
  {
    code: "183",
    descriptionAr: "بليز",
    descriptionEn: "BELIZE",
  },
  {
    code: "64",
    descriptionAr: "بنين",
    descriptionEn: "BENIN",
  },
  {
    code: "184",
    descriptionAr: "برمودا",
    descriptionEn: "BERMUDA",
  },
  {
    code: "145",
    descriptionAr: "بوتان",
    descriptionEn: "BHUTAN",
  },
  {
    code: "1048",
    descriptionAr: "بيشة",
    descriptionEn: "BISHA",
  },
  {
    code: "22",
    descriptionAr: "",
    descriptionEn: "BISHAH",
  },
  {
    code: "209",
    descriptionAr: "بوليفيا",
    descriptionEn: "BOLIVIA",
  },
  {
    code: "185",
    descriptionAr: "بونير",
    descriptionEn: "BONAIRE",
  },
  {
    code: "146",
    descriptionAr: "بورنيو",
    descriptionEn: "BORNEO",
  },
  {
    code: "65",
    descriptionAr: "بوتسوانا",
    descriptionEn: "BOTSWANA",
  },
  {
    code: "210",
    descriptionAr: "البرازيل",
    descriptionEn: "BRAZIL",
  },
  {
    code: "147",
    descriptionAr: "بروني",
    descriptionEn: "BRUNEI",
  },
  {
    code: "114",
    descriptionAr: "بلغاريا",
    descriptionEn: "BULGARIA",
  },
  {
    code: "16",
    descriptionAr: "بريدة",
    descriptionEn: "BURAYDA",
  },
  {
    code: "66",
    descriptionAr: "بوركينا فاسو",
    descriptionEn: "BURKINA FASO",
  },
  {
    code: "148",
    descriptionAr: "بورما",
    descriptionEn: "BURMA",
  },
  {
    code: "67",
    descriptionAr: "بوروندي",
    descriptionEn: "BURUNDI",
  },
  {
    code: "1058",
    descriptionAr: "مركز البطحاء الحدودي",
    descriptionEn: "Batha Border Center",
  },
  {
    code: "149",
    descriptionAr: "كمبوديا",
    descriptionEn: "CAMBODIA",
  },
  {
    code: "68",
    descriptionAr: "الكاميرون",
    descriptionEn: "CAMEROON",
  },
  {
    code: "176",
    descriptionAr: "كندا",
    descriptionEn: "CANADA",
  },
  {
    code: "62",
    descriptionAr: "كندا",
    descriptionEn: "CANADA",
  },
  {
    code: "69",
    descriptionAr: "جمهورية أمريكا الوسطى",
    descriptionEn: "CENTRAL AMERICAN REP.",
  },
  {
    code: "1064",
    descriptionAr: "المنطقة الوسطى السعودية",
    descriptionEn: "CENTRAL REGION KSA",
  },
  {
    code: "70",
    descriptionAr: "تشاد",
    descriptionEn: "CHAD",
  },
  {
    code: "211",
    descriptionAr: "تشيلي",
    descriptionEn: "CHILE",
  },
  {
    code: "150",
    descriptionAr: "الصين",
    descriptionEn: "CHINA",
  },

  {
    code: "212",
    descriptionAr: "كولومبيا",
    descriptionEn: "COLOMBIA",
  },
  {
    code: "151",
    descriptionAr: "جزر القمر",
    descriptionEn: "COMOROS",
  },
  {
    code: "71",
    descriptionAr: "كونغو",
    descriptionEn: "CONGO",
  },
  {
    code: "186",
    descriptionAr: "كوستاريكا",
    descriptionEn: "COSTA RICA",
  },
  {
    code: "187",
    descriptionAr: "كوبا",
    descriptionEn: "CUBA",
  },
  {
    code: "188",
    descriptionAr: "كوراكاو",
    descriptionEn: "CURACAO",
  },
  {
    code: "115",
    descriptionAr: "قبرص",
    descriptionEn: "CYPRUS",
  },
  {
    code: "116",
    descriptionAr: "تشيكوسلوفاكيا",
    descriptionEn: "CZECHOSLOVAKIA",
  },
  {
    code: "72",
    descriptionAr: "داهومي",
    descriptionEn: "DAHOMEY",
  },
  {
    code: "3",
    descriptionAr: "الدمام",
    descriptionEn: "DAMMAM",
  },
  {
    code: "25",
    descriptionAr: "الدمام خضرية",
    descriptionEn: "DAMMAM KHADRIA",
  },
  {
    code: "117",
    descriptionAr: "الدنمارك",
    descriptionEn: "DENMARK",
  },
  {
    code: "1065",
    descriptionAr: "دابان",
    descriptionEn: "DHABAN",
  },
  {
    code: "8",
    descriptionAr: "الظهران",
    descriptionEn: "DHAHRAN",
  },
  {
    code: "227",
    descriptionAr: "الظهران الجنوبي",
    descriptionEn: "DHAHRAN ALJANOUB",
  },
  {
    code: "1020",
    descriptionAr: "ميناء دبا",
    descriptionEn: "DIBA PORT",
  },
  {
    code: "73",
    descriptionAr: "جيبوتي",
    descriptionEn: "DJIBOUTI",
  },
  {
    code: "190",
    descriptionAr: "ممثل الدومينكان",
    descriptionEn: "DOMINCAN REP",
  },
  {
    code: "189",
    descriptionAr: "دومينيكا",
    descriptionEn: "DOMINICA",
  },
  {
    code: "268",
    descriptionAr: "دومات القندل",
    descriptionEn: "DOWMAT ALGANDAL",
  },
  {
    code: "1059",
    descriptionAr: "دوبا",
    descriptionEn: "DUBA",
  },
  {
    code: "230",
    descriptionAr: "دبي",
    descriptionEn: "DUBAI",
  },
  {
    code: "255",
    descriptionAr: "دكنة",
    descriptionEn: "DUKNAH",
  },
  {
    code: "234",
    descriptionAr: "دورما",
    descriptionEn: "DURMA",
  },
  {
    code: "241",
    descriptionAr: "المنطقة الشرقية",
    descriptionEn: "EASTERN PROVINCE",
  },
  {
    code: "1068",
    descriptionAr: "المنطقة الشرقية السعودية",
    descriptionEn: "EASTERN REGION - K S A",
  },
  {
    code: "213",
    descriptionAr: "الإكوادور",
    descriptionEn: "ECUADOR",
  },
  {
    code: "50",
    descriptionAr: "مصر",
    descriptionEn: "EGYPT",
  },
  {
    code: "118",
    descriptionAr: "إيري",
    descriptionEn: "EIRE",
  },
  {
    code: "191",
    descriptionAr: "السلفادور",
    descriptionEn: "EL SALVADOR",
  },
  {
    code: "1070",
    descriptionAr: "الربع الخالي",
    descriptionEn: "EMPTY QUARTER",
  },
  {
    code: "74",
    descriptionAr: "غينيا الاستوائية",
    descriptionEn: "EQUATORIAL GUINEA",
  },
  {
    code: "75",
    descriptionAr: "إثيوبيا",
    descriptionEn: "ETHIOPIA",
  },
  {
    code: "1046",
    descriptionAr: "أدخل اللغة الإنجليزية",
    descriptionEn: "Enter ENGLISH description ...",
  },
  {
    code: "1033",
    descriptionAr: "أدخل اللغة الإنجليزية",
    descriptionEn: "Enter ENGLISH description ...",
  },
  {
    code: "1040",
    descriptionAr: "أدخل اللغة الإنجليزية",
    descriptionEn: "Enter ENGLISH description ...",
  },
  {
    code: "1061",
    descriptionAr: "أدخل اللغة الإنجليزية",
    descriptionEn: "Enter ENGLISH description ...",
  },
  {
    code: "222",
    descriptionAr: "فيجي",
    descriptionEn: "FIJI",
  },
  {
    code: "119",
    descriptionAr: "فنلندا",
    descriptionEn: "FINLAND",
  },
  {
    code: "120",
    descriptionAr: "فرنسا",
    descriptionEn: "FRANCE",
  },
  {
    code: "18",
    descriptionAr: "فرنسا",
    descriptionEn: "FRANCE",
  },
  {
    code: "76",
    descriptionAr: "الغابون",
    descriptionEn: "GABON",
  },
  {
    code: "77",
    descriptionAr: "غامبيا",
    descriptionEn: "GAMBIA",
  },
  {
    code: "121",
    descriptionAr: "ألمانيا",
    descriptionEn: "GERMANY",
  },
  {
    code: "78",
    descriptionAr: "غانا",
    descriptionEn: "GHANA",
  },
  {
    code: "122",
    descriptionAr: "جبل طارق",
    descriptionEn: "GIBRALTAR",
  },
  {
    code: "123",
    descriptionAr: "اليونان",
    descriptionEn: "GREECE",
  },
  {
    code: "192",
    descriptionAr: "غرينادا",
    descriptionEn: "GRENADA",
  },
  {
    code: "193",
    descriptionAr: "غوادالوبي",
    descriptionEn: "GUADALOUPE",
  },
  {
    code: "194",
    descriptionAr: "غواتيمالا",
    descriptionEn: "GUATEMALA",
  },
  {
    code: "79",
    descriptionAr: "غينيا",
    descriptionEn: "GUINEA",
  },
  {
    code: "80",
    descriptionAr: "غينيا - بيساو",
    descriptionEn: "GUINEA - BISSAU",
  },
  {
    code: "23",
    descriptionAr: "خليج المكسيك",
    descriptionEn: "GULF OF MEXICO",
  },
  {
    code: "214",
    descriptionAr: "غيانا",
    descriptionEn: "GUYANA",
  },
  {
    code: "267",
    descriptionAr: "حفر الباطن",
    descriptionEn: "HAFAR AL BATIN",
  },
  {
    code: "1022",
    descriptionAr: "حائل",
    descriptionEn: "HAIL",
  },
  {
    code: "195",
    descriptionAr: "هايتي",
    descriptionEn: "HAITI",
  },
  {
    code: "1004",
    descriptionAr: "حالة عمار",
    descriptionEn: "HALAT AMMAR",
  },
  {
    code: "1024",
    descriptionAr: "حراض",
    descriptionEn: "HARADH",
  },
  {
    code: "239",
    descriptionAr: "حوتة بني تميم",
    descriptionEn: "HAWTAT BANI TAMIM",
  },
  {
    code: "40",
    descriptionAr: "هايل",
    descriptionEn: "HAYIL",
  },
  {
    code: "246",
    descriptionAr: "الهوف",
    descriptionEn: "HOFUF",
  },
  {
    code: "196",
    descriptionAr: "هندوراس",
    descriptionEn: "HONDURAS",
  },
  {
    code: "153",
    descriptionAr: "هونغ كونغ",
    descriptionEn: "HONG KONG",
  },
  {
    code: "1076",
    descriptionAr: "هوتا سدير",
    descriptionEn: "HOTA SADEER",
  },
  {
    code: "124",
    descriptionAr: "هنغاريا",
    descriptionEn: "HUNGARY",
  },
  {
    code: "235",
    descriptionAr: "هوريمالا",
    descriptionEn: "HURAYMALA",
  },
  {
    code: "125",
    descriptionAr: "أيسلندا",
    descriptionEn: "ICELAND",
  },
  {
    code: "154",
    descriptionAr: "الهند",
    descriptionEn: "INDIA",
  },
  {
    code: "155",
    descriptionAr: "إندونيسيا",
    descriptionEn: "INDONESIA",
  },
  {
    code: "156",
    descriptionAr: "إيران",
    descriptionEn: "IRAN",
  },
  {
    code: "51",
    descriptionAr: "العراق",
    descriptionEn: "IRAQ",
  },
  {
    code: "126",
    descriptionAr: "إيطاليا",
    descriptionEn: "ITALY",
  },
  {
    code: "81",
    descriptionAr: "ساحل العاج",
    descriptionEn: "IVORY COAST",
  },
  {
    code: "236",
    descriptionAr: "جلاجل",
    descriptionEn: "JALAJIL",
  },
  {
    code: "197",
    descriptionAr: "جامايكا",
    descriptionEn: "JAMAICA",
  },
  {
    code: "157",
    descriptionAr: "اليابان",
    descriptionEn: "JAPAN",
  },
  {
    code: "14",
    descriptionAr: "جازان",
    descriptionEn: "JAZAN",
  },
  {
    code: "2",
    descriptionAr: "جدة",
    descriptionEn: "JEDDAH",
  },
  {
    code: "1016",
    descriptionAr: "جدة والرياض",
    descriptionEn: "JEDDAH & RIYADH",
  },
  {
    code: "52",
    descriptionAr: "الأردن",
    descriptionEn: "JORDAN",
  },
  {
    code: "292",
    descriptionAr: "يهوذا",
    descriptionEn: "JUDAH",
  },
  {
    code: "82",
    descriptionAr: "كينيا",
    descriptionEn: "KENYA",
  },
  {
    code: "1005",
    descriptionAr: "خيبر",
    descriptionEn: "KHAIBAR",
  },
  {
    code: "10",
    descriptionAr: "خميس مشيط",
    descriptionEn: "KHAMIS MUSHAYT",
  },
  {
    code: "1028",
    descriptionAr: "كسرى",
    descriptionEn: "KHASRA",
  },
  {
    code: "259",
    descriptionAr: "المملكة العربية السعودية",
    descriptionEn: "KINGDOM OF SAUDI ARABIA",
  },
  {
    code: "1017",
    descriptionAr: "المملكة العربية السعودية ومياهها الإقليمية",
    descriptionEn: "KSA & ITS TERRITORIAL WATERS",
  },
  {
    code: "1081",
    descriptionAr: "المملكة العربية السعودية ومياهها الإقليمية",
    descriptionEn: "KSA AND GCC COUNTRIES.",
  },
  {
    code: "45",
    descriptionAr: "الكويت",
    descriptionEn: "KUWAIT",
  },
  {
    code: "160",
    descriptionAr: "لاوس",
    descriptionEn: "LAOS",
  },
  {
    code: "237",
    descriptionAr: "ليلى",
    descriptionEn: "LAYLA",
  },
  {
    code: "53",
    descriptionAr: "لبنان",
    descriptionEn: "LEBANON",
  },
  {
    code: "83",
    descriptionAr: "ليسوتو",
    descriptionEn: "LESOTHO",
  },
  {
    code: "84",
    descriptionAr: "ليبيريا",
    descriptionEn: "LIBERIA",
  },
  {
    code: "54",
    descriptionAr: "ليبيا",
    descriptionEn: "LIBYA",
  },
  {
    code: "127",
    descriptionAr: "ليختنشتاين",
    descriptionEn: "LIECHTENSTEIN",
  },
  {
    code: "128",
    descriptionAr: "لوكسمبورغ",
    descriptionEn: "LUXEMBOURG",
  },
  {
    code: "161",
    descriptionAr: "ماكاو",
    descriptionEn: "MACAU",
  },
  {
    code: "85",
    descriptionAr: "مدغشقر",
    descriptionEn: "MADAGASCAR",
  },
  {
    code: "1069",
    descriptionAr: "محايل عسير",
    descriptionEn: "MAHAIL ASSER",
  },
  {
    code: "1018",
    descriptionAr: "مهد الدهب",
    descriptionEn: "MAHD AL DAHAB",
  },
  {
    code: "11",
    descriptionAr: "مكة المكرمة",
    descriptionEn: "MAKKAH AL-MUKARRAMAH",
  },
  {
    code: "86",
    descriptionAr: "ممثل مدغشقر",
    descriptionEn: "MALAGASY REP.",
  },
  {
    code: "87",
    descriptionAr: "ملاوي",
    descriptionEn: "MALAWI",
  },
  {
    code: "162",
    descriptionAr: "ماليزيا",
    descriptionEn: "MALAYSIA",
  },
  {
    code: "163",
    descriptionAr: "جزر المالديف",
    descriptionEn: "MALDIVES",
  },
  {
    code: "88",
    descriptionAr: "مالي",
    descriptionEn: "MALI",
  },
  {
    code: "129",
    descriptionAr: "مالطا",
    descriptionEn: "MALTA",
  },
  {
    code: "198",
    descriptionAr: "مارتينيك",
    descriptionEn: "MARTINIQUE",
  },
  {
    code: "89",
    descriptionAr: "موريتانيا",
    descriptionEn: "MAURITANIA",
  },
  {
    code: "90",
    descriptionAr: "موريشيوس",
    descriptionEn: "MAURITIUS",
  },
  {
    code: "199",
    descriptionAr: "المكسيك",
    descriptionEn: "MEXICO",
  },
  {
    code: "220",
    descriptionAr: "ميكرونيزيا",
    descriptionEn: "MICRONESIA",
  },
  {
    code: "130",
    descriptionAr: "موناكو",
    descriptionEn: "MONACO",
  },
  {
    code: "164",
    descriptionAr: "منغوليا",
    descriptionEn: "MONGOLIA",
  },
  {
    code: "200",
    descriptionAr: "مونتسيرات",
    descriptionEn: "MONTSERRAT",
  },
  {
    code: "269",
    descriptionAr: "مقيق",
    descriptionEn: "MOQIQ",
  },
  {
    code: "55",
    descriptionAr: "المغرب",
    descriptionEn: "MOROCCO",
  },
  {
    code: "91",
    descriptionAr: "موزمبيق",
    descriptionEn: "MOZAMBIQUE",
  },
  {
    code: "1002",
    descriptionAr: "الموزهمية",
    descriptionEn: "MUZAHMIYAH",
  },
  {
    code: "36",
    descriptionAr: "نجران",
    descriptionEn: "NAJRAN",
  },
  {
    code: "92",
    descriptionAr: "ناميبيا",
    descriptionEn: "NAMIBIA",
  },
  {
    code: "165",
    descriptionAr: "ناورو",
    descriptionEn: "NAURU",
  },
  {
    code: "1080",
    descriptionAr: "نيوم",
    descriptionEn: "NEOM",
  },
  {
    code: "166",
    descriptionAr: "نيبال",
    descriptionEn: "NEPAL",
  },
  {
    code: "131",
    descriptionAr: "هولندا",
    descriptionEn: "NETHERLANDS",
  },
  {
    code: "221",
    descriptionAr: "نيوزيلندا",
    descriptionEn: "NEW ZEALAND",
  },
  {
    code: "201",
    descriptionAr: "نيكاراغوا",
    descriptionEn: "NICARAGUA",
  },
  {
    code: "93",
    descriptionAr: "النيجر",
    descriptionEn: "NIGER",
  },
  {
    code: "94",
    descriptionAr: "نيجيريا",
    descriptionEn: "NIGERIA",
  },
  {
    code: "158",
    descriptionAr: "كوريا الشمالية",
    descriptionEn: "NORTH KOREA",
  },
  {
    code: "19",
    descriptionAr: "بحر الشمال",
    descriptionEn: "NORTH SEA",
  },
  {
    code: "1073",
    descriptionAr: "منطقة الحدود الشمالية",
    descriptionEn: "NORTHERN BORDER REGION",
  },
  {
    code: "1067",
    descriptionAr: "المنطقة الشمالية السعودية",
    descriptionEn: "NORTHERN REGION  - K S A",
  },
  {
    code: "132",
    descriptionAr: "النرويج",
    descriptionEn: "NORWAY",
  },
  {
    code: "999",
    descriptionAr: "غير محدد",
    descriptionEn: "NOT DEFIENED",
  },
  {
    code: "1071",
    descriptionAr: "عمان",
    descriptionEn: "OMAN",
  },
  {
    code: "46",
    descriptionAr: "عمان",
    descriptionEn: "OMAN",
  },
  {
    code: "167",
    descriptionAr: "باكستان",
    descriptionEn: "PAKISTAN",
  },
  {
    code: "56",
    descriptionAr: "فلسطين",
    descriptionEn: "PALESTINE",
  },
  {
    code: "202",
    descriptionAr: "بنما",
    descriptionEn: "PANAMA",
  },
  {
    code: "168",
    descriptionAr: "بابوا",
    descriptionEn: "PAPUA - NEW GUINEA",
  },
  {
    code: "215",
    descriptionAr: "باراغواي",
    descriptionEn: "PARAGUAY",
  },
  {
    code: "216",
    descriptionAr: "بيرو",
    descriptionEn: "PERU",
  },
  {
    code: "169",
    descriptionAr: "الفلبين",
    descriptionEn: "PHILIPPINES",
  },
  {
    code: "133",
    descriptionAr: "بولندا",
    descriptionEn: "POLAND",
  },
  {
    code: "134",
    descriptionAr: "البرتغال",
    descriptionEn: "PORTUGAL",
  },
  {
    code: "203",
    descriptionAr: "بورتوريكو",
    descriptionEn: "PUERTO RICO",
  },
  {
    code: "270",
    descriptionAr: "قارة",
    descriptionEn: "QARAH",
  },
  {
    code: "281",
    descriptionAr: "القصيم",
    descriptionEn: "QASSIM",
  },
  {
    code: "47",
    descriptionAr: "قطر",
    descriptionEn: "QATAR",
  },
  {
    code: "1078",
    descriptionAr: "القرية ",
    descriptionEn: "QURAYYAH, KSA",
  },
  {
    code: "242",
    descriptionAr: "رابغ",
    descriptionEn: "RABIGH",
  },
  {
    code: "283",
    descriptionAr: "رفحاء",
    descriptionEn: "RAFHA",
  },
  {
    code: "243",
    descriptionAr: "رحيمة",
    descriptionEn: "RAHIMA",
  },
  {
    code: "1038",
    descriptionAr: "رانيا",
    descriptionEn: "RANIYA",
  },
  {
    code: "32",
    descriptionAr: "رأس تنورا",
    descriptionEn: "RAS TANURA",
  },
  {
    code: "1066",
    descriptionAr: "رأس الزور",
    descriptionEn: "RAZ AZ ZAWR",
  },
  {
    code: "28",
    descriptionAr: "الباقي المركزي",
    descriptionEn: "REMAINDER CENTRAL",
  },
  {
    code: "33",
    descriptionAr: "الباقي الشرقي",
    descriptionEn: "REMAINDER EASTERN",
  },
  {
    code: "43",
    descriptionAr: "الباقي الشمالي",
    descriptionEn: "REMAINDER NORTHERN",
  },
  {
    code: "38",
    descriptionAr: "الباقي جنوبا",
    descriptionEn: "REMAINDER SOUTHERN",
  },
  {
    code: "34",
    descriptionAr: "الباقي الغربي",
    descriptionEn: "REMAINDER WESTERN",
  },
  {
    code: "95",
    descriptionAr: "لم الشمل",
    descriptionEn: "REUNION",
  },
  {
    code: "1052",
    descriptionAr: "ريجال الما",
    descriptionEn: "RIGAL ALMAA",
  },
  {
    code: "1047",
    descriptionAr: "رماح",
    descriptionEn: "RIMAH",
  },
  {
    code: "135",
    descriptionAr: "رومانيا",
    descriptionEn: "ROMANIA",
  },
  {
    code: "141",
    descriptionAr: "روسيا",
    descriptionEn: "RUSSIA",
  },
  {
    code: "96",
    descriptionAr: "رواندا",
    descriptionEn: "RWANDA",
  },
  {
    code: "1037",
    descriptionAr: "رانيا",
    descriptionEn: "Raniya",
  },
  {
    code: "1056",
    descriptionAr: "سابيا",
    descriptionEn: "SABIA",
  },
  {
    code: "223",
    descriptionAr: "صفوى",
    descriptionEn: "SAFWA",
  },
  {
    code: "257",
    descriptionAr: "ساجر",
    descriptionEn: "SAJIR",
  },
  {
    code: "41",
    descriptionAr: "سكاكا",
    descriptionEn: "SAKAKAH",
  },
  {
    code: "228",
    descriptionAr: "سميطة",
    descriptionEn: "SAMITAH",
  },
  {
    code: "170",
    descriptionAr: "ساموا",
    descriptionEn: "SAMOA",
  },
  {
    code: "229",
    descriptionAr: "سبت العليا",
    descriptionEn: "SAPT AL ALAYA",
  },
  {
    code: "231",
    descriptionAr: "سارات عبيدة",
    descriptionEn: "SARAT ABIDAH",
  },
  {
    code: "293",
    descriptionAr: "المملكة العربية السعودية",
    descriptionEn: "SAUDI ARABIA",
  },
  {
    code: "97",
    descriptionAr: "السنغال",
    descriptionEn: "SENEGAL",
  },
  {
    code: "98",
    descriptionAr: "سيشيل",
    descriptionEn: "SEYCHELLES",
  },
  {
    code: "247",
    descriptionAr: "شقراء",
    descriptionEn: "SHAQRA",
  },
  {
    code: "37",
    descriptionAr: "شرورة",
    descriptionEn: "SHAROURAH",
  },
  {
    code: "263",
    descriptionAr: "شهداء، وادي ليا، غايا وثاجيف",
    descriptionEn: "SHUHADA,WADI LIYA,GAYA&THAGIF",
  },
  {
    code: "99",
    descriptionAr: "سييرا ليون",
    descriptionEn: "SIERRA LEONE",
  },
  {
    code: "240",
    descriptionAr: "سيهات",
    descriptionEn: "SIHAT",
  },
  {
    code: "171",
    descriptionAr: "سنغافورة",
    descriptionEn: "SINGAPORE",
  },
  {
    code: "100",
    descriptionAr: "الصومال",
    descriptionEn: "SOMALIA",
  },
  {
    code: "101",
    descriptionAr: "جنوب أفريقيا",
    descriptionEn: "SOUTH AFRICA",
  },
  {
    code: "159",
    descriptionAr: "كوريا الجنوبية",
    descriptionEn: "SOUTH KOREA",
  },
  {
    code: "1035",
    descriptionAr: "المنطقة الجنوبية",
    descriptionEn: "SOUTHERN REGION",
  },
  {
    code: "136",
    descriptionAr: "إسبانيا",
    descriptionEn: "SPAIN",
  },
  {
    code: "172",
    descriptionAr: "سريلانكا",
    descriptionEn: "SRI LANKA",
  },
  {
    code: "207",
    descriptionAr: "سانت كيتس",
    descriptionEn: "ST. KITTS",
  },
  {
    code: "57",
    descriptionAr: "السودان",
    descriptionEn: "SUDAN",
  },
  {
    code: "217",
    descriptionAr: "سورينام",
    descriptionEn: "SURINAM",
  },
  {
    code: "102",
    descriptionAr: "سوازيلاند",
    descriptionEn: "SWAZILAND",
  },
  {
    code: "137",
    descriptionAr: "السويد",
    descriptionEn: "SWEDEN",
  },
  {
    code: "138",
    descriptionAr: "سويسرا",
    descriptionEn: "SWITZERLAND",
  },
  {
    code: "58",
    descriptionAr: "سوريا",
    descriptionEn: "SYRIA",
  },
  {
    code: "1029",
    descriptionAr: "الشعيبة",
    descriptionEn: "Shoaiba",
  },
  {
    code: "301",
    descriptionAr: "سدير",
    descriptionEn: "Sudair",
  },
  {
    code: "271",
    descriptionAr: "طبرجل",
    descriptionEn: "TABARJAL",
  },
  {
    code: "15",
    descriptionAr: "تبوك",
    descriptionEn: "TABOUK",
  },
  {
    code: "249",
    descriptionAr: "الطائف",
    descriptionEn: "TAIF",
  },
  {
    code: "272",
    descriptionAr: "تيماء",
    descriptionEn: "TAIMA",
  },
  {
    code: "173",
    descriptionAr: "تايوان",
    descriptionEn: "TAIWAN",
  },
  {
    code: "103",
    descriptionAr: "تنزانيا",
    descriptionEn: "TANZANIA",
  },
  {
    code: "174",
    descriptionAr: "تايلاند",
    descriptionEn: "THAILAND",
  },
  {
    code: "104",
    descriptionAr: "توغو",
    descriptionEn: "TOGO",
  },
  {
    code: "204",
    descriptionAr: "ترينيداد",
    descriptionEn: "TRINIDAD",
  },
  {
    code: "59",
    descriptionAr: "تونس",
    descriptionEn: "TUNISIA",
  },
  {
    code: "42",
    descriptionAr: "طريف",
    descriptionEn: "TURAYF",
  },
  {
    code: "273",
    descriptionAr: "ترباح",
    descriptionEn: "TURBAH",
  },
  {
    code: "139",
    descriptionAr: "تركيا",
    descriptionEn: "TURKEY",
  },
  {
    code: "205",
    descriptionAr: "تركس وكايكوس",
    descriptionEn: "TURKS & CAICOS",
  },
  {
    code: "48",
    descriptionAr: "الإمارات العربية المتحدة",
    descriptionEn: "U. A. E.",
  },
  {
    code: "177",
    descriptionAr: "الولايات المتحدة الأمريكية",
    descriptionEn: "U. S. A.",
  },
  {
    code: "1019",
    descriptionAr: "الشارقة",
    descriptionEn: "U.A.E. - SHARJAH",
  },
  {
    code: "61",
    descriptionAr: "الولايات المتحدة الأمريكية",
    descriptionEn: "U.S.A.",
  },
  {
    code: "105",
    descriptionAr: "أوغاندا",
    descriptionEn: "UGANDA",
  },
  {
    code: "274",
    descriptionAr: "أملج",
    descriptionEn: "UMLUJ",
  },
  {
    code: "12",
    descriptionAr: "عنيزة",
    descriptionEn: "UNAYZAH",
  },
  {
    code: "1077",
    descriptionAr: "الإمارات العربية المتحدة",
    descriptionEn: "UNITED ARAB EMIRATE",
  },
  {
    code: "7",
    descriptionAr: "المملكة المتحدة",
    descriptionEn: "UNITED KINGDOM",
  },
  {
    code: "140",
    descriptionAr: "المملكة المتحدة",
    descriptionEn: "UNITED KINGDOM",
  },
  {
    code: "261",
    descriptionAr: "قلعة السجور",
    descriptionEn: "UQLAT AL SUGUR",
  },
  {
    code: "1030",
    descriptionAr: "عشيرة",
    descriptionEn: "USHAYRA",
  },
  {
    code: "262",
    descriptionAr: "عيون الجوة",
    descriptionEn: "UYUN AL JIWA",
  },
  {
    code: "1015",
    descriptionAr: "مواقع مختلفة في المملكة العربية السعودية",
    descriptionEn: "VARIOUS LOCATIONS IN KSA",
  },
  {
    code: "218",
    descriptionAr: "فنزويلا",
    descriptionEn: "VENEZUELA",
  },
  {
    code: "175",
    descriptionAr: "فيتنام",
    descriptionEn: "VIETNAM",
  },
  {
    code: "206",
    descriptionAr: "جزر فيرجن",
    descriptionEn: "VIRGIN ISLANDS",
  },
  {
    code: "26",
    descriptionAr: "وادي الدواسر",
    descriptionEn: "WADI AL DAWASIR",
  },
  {
    code: "294",
    descriptionAr: "غرب افريقيا",
    descriptionEn: "WEST AFRICA",
  },
  {
    code: "1063",
    descriptionAr: "المنطقة الغربية بالمملكة العربية السعودية",
    descriptionEn: "WESTERN REGION KSA",
  },
  {
    code: "106",
    descriptionAr: "الصحراء الغربية",
    descriptionEn: "WESTERN SAHARA",
  },
  {
    code: "248",
    descriptionAr: "جميع أنحاء العالم",
    descriptionEn: "WORLDWIDE",
  },
  {
    code: "1001",
    descriptionAr: " جميع أنحاء العالم باستثناء الولايات المتحدة الأمريكية وكندا",
    descriptionEn: "WORLDWIDE EXCL. USA & CANADA",
  },
  {
    code: "1000",
    descriptionAr: "جميع أنحاء العالم بما في ذلك الولايات المتحدة الأمريكية وكندا",
    descriptionEn: "WORLDWIDE INCL. USA & CANADA",
  },
  {
    code: "1032",
    descriptionAr: "وادي حبونة",
    descriptionEn: "Wadi Habbounah",
  },
  {
    code: "1",
    descriptionAr: "XXXX",
    descriptionEn: "XXXX",
  },
  {
    code: "260",
    descriptionAr: "ينبع",
    descriptionEn: "YANBU",
  },
  {
    code: "9",
    descriptionAr: "ينبع الصناعية",
    descriptionEn: "YANBU AL SINAIYAH",
  },
  {
    code: "60",
    descriptionAr: "اليمن",
    descriptionEn: "YEMEN",
  },
  {
    code: "142",
    descriptionAr: "يوغوسلافيا",
    descriptionEn: "YUGOSLAVIA",
  },
  {
    code: "108",
    descriptionAr: "زامبيا",
    descriptionEn: "ZAMBIA",
  },
  {
    code: "107",
    descriptionAr: "زياري",
    descriptionEn: "ZIARE",
  },
  {
    code: "109",
    descriptionAr: "زيمبابوي",
    descriptionEn: "ZIMBABWE",
  },
];

export const IdentificationList = [
  { code: "National ID", descriptionAr: "الهوية الوطنية", descriptionEn: "National ID" },
  { code: "Passport", descriptionAr: "جواز السفر", descriptionEn: "Passport" },
  { code: "Border", descriptionAr: "الحدود", descriptionEn: "Border" },
  { code: "Iqama ID", descriptionAr: "إقامة", descriptionEn: "Iqama ID" },
];

export const MaritalStatusList = [
  {
    maritalStatus: "UnMarried",
    maritalStatusAR: "غير متزوج",
    maritalStatusCode: "U",
  },
  {
    maritalStatus: "Married",
    maritalStatusAR: "متزوج",
    maritalStatusCode: "M",
  },
];
export const DisctrictList = [
  {
    regionCode: "1",
    regionName: "Riyadh",
  },
  {
    regionCode: "2",
    regionName: "Makkah Al Mukuramah",
  },
  {
    regionCode: "3",
    regionName: "Eastern Region",
  },
  {
    regionCode: "4",
    regionName: "Al Madina Al Munawara / Tabuk",
  },
  {
    regionCode: "5",
    regionName: "Qassim / Hail",
  },
  {
    regionCode: "6",
    regionName: "Asseer / Najran / Baha",
  },
  {
    regionCode: "7",
    regionName: "Northern Boarders Region / Jouf",
  },
  {
    regionCode: "8",
    regionName: "Jazan",
  },
];
export const ZoneList = [
  {
    regionCode: "1",
    descriptionEn: "Riyadh",
    descriptionAr: "منطقة الرياض",
  },
  {
    regionCode: "2",
    descriptionEn: "Makkah Al Mukuramah",
    descriptionAr: "منطقه مكة المكرمة",
  },
  {
    regionCode: "3",
    descriptionEn: "Eastern Region",
    descriptionAr: "المنطقة الشرقية",
  },
  {
    regionCode: "4",
    descriptionEn: "Al Madina Al Munawara / Tabuk",
    descriptionAr: "منطقة المدينة المنورة / منطقة تبوك",
  },
  {
    regionCode: "5",
    descriptionEn: "Qassim / Hail",
    descriptionAr: "منطقة القصيم / منطقة حائل",
  },
  {
    regionCode: "6",
    descriptionEn: "Asseer / Najran / Baha",
    descriptionAr: "منطقة عسير / منطقة نجران / منطقة الباحة",
  },
  {
    regionCode: "7",
    descriptionEn: "Northern Boarders Region / Jouf",
    descriptionAr: "منطقة الحدود الشمالية / منطقة الجوف",
  },
  {
    regionCode: "8",
    descriptionEn: "Jazan",
    descriptionAr: "منطقة جازان",
  },
];
export const sourceofIncomeList = [
  { code: "Salary", descriptionEn: "Salary", descriptionAr: "الراتب" },
  { code: "Student stipend", descriptionEn: "Student stipend", descriptionAr: "الراتب" },
  { code: "Government subsidy", descriptionEn: "Government subsidy", descriptionAr: "راتب طالب" },
  { code: "Family allowance", descriptionEn: "Family allowance", descriptionAr: "إعانة أسرية" },
  { code: "Business", descriptionEn: "Business", descriptionAr: "تجارة" },
  { code: "Other", descriptionEn: "Other", descriptionAr: "آخرى" },
  { code: "Retirement salary", descriptionEn: "Retirement salary", descriptionAr: "راتب التقاعد" },
];

export const professionList = [
  {
    trade_desc: "RETIRED",
    trade_desc_ar: "متقاعد",
    trade_code: "001",
  },
  {
    trade_desc: "UNEMPLOYED",
    trade_desc_ar: "عاطل",
    trade_code: "000",
  },
  {
    trade_desc: "PHARMACIST",
    trade_desc_ar: "صيدلي",
    trade_code: "26",
  },
  {
    trade_desc: "NURSE (EXCLUDING MIDWIFERY)",
    trade_desc_ar: "ممرض",
    trade_code: "29",
  },
  {
    trade_desc: "DIETICIAN",
    trade_desc_ar: "أخصائي تغذية",
    trade_code: "31",
  },
  {
    trade_desc: "LABORATORY OR PATHOLOGY TECHNICIAN",
    trade_desc_ar: "",
    trade_code: "35",
  },
  {
    trade_desc: "X-RAY TECHNICIAN",
    trade_desc_ar: "",
    trade_code: "39",
  },
  {
    trade_desc: "SCANNING TECHNICIAN",
    trade_desc_ar: "",
    trade_code: "40",
  },
  {
    trade_desc: "PATHOLOGIST",
    trade_desc_ar: "",
    trade_code: "41",
  },
  {
    trade_desc: "PHYSIOTHERAPIST",
    trade_desc_ar: "",
    trade_code: "42",
  },
  {
    trade_desc: "DOCTOR - GENERAL PRACTITIONER",
    trade_desc_ar: "",
    trade_code: "43",
  },
  {
    trade_desc: "PYSCHIATRIST",
    trade_desc_ar: "",
    trade_code: "45",
  },
  {
    trade_desc: "RADIOLOGIST",
    trade_desc_ar: "",
    trade_code: "47",
  },
  {
    trade_desc: "OPHTHALMOLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "48",
  },
  {
    trade_desc: "MIDWIFE",
    trade_desc_ar: "",
    trade_code: "49",
  },
  {
    trade_desc: "VASCULAR SURGEON",
    trade_desc_ar: "",
    trade_code: "50",
  },
  {
    trade_desc: "CARDIOVASCULAR SURGEON",
    trade_desc_ar: "",
    trade_code: "51",
  },
  {
    trade_desc: "MAXILLOFACIAL  SURGEON",
    trade_desc_ar: "",
    trade_code: "52",
  },
  {
    trade_desc: "THORACIC SURGEON",
    trade_desc_ar: "",
    trade_code: "54",
  },
  {
    trade_desc: "OPHTHALMOLOGIST (INCLUDING SURGERY)",
    trade_desc_ar: "",
    trade_code: "57",
  },
  {
    trade_desc: "NEUROLOGIST",
    trade_desc_ar: "",
    trade_code: "59",
  },
  {
    trade_desc: "PLASTIC SURGEON",
    trade_desc_ar: "",
    trade_code: "63",
  },
  {
    trade_desc: "VENEREAL DISEASE SPECIALIST",
    trade_desc_ar: "",
    trade_code: "65",
  },
  {
    trade_desc: "DENTIST",
    trade_desc_ar: "",
    trade_code: "521",
  },
  {
    trade_desc: "GENERAL SURGEON",
    trade_desc_ar: "",
    trade_code: "2105",
  },
  {
    trade_desc: "GYNECOLOGIST",
    trade_desc_ar: "",
    trade_code: "2106",
  },
  {
    trade_desc: "CARDIOLOGIST",
    trade_desc_ar: "",
    trade_code: "2107",
  },
  {
    trade_desc: "ANAESTHETIST",
    trade_desc_ar: "",
    trade_code: "2108",
  },
  {
    trade_desc: "DOCTOR  (INCLUDING SURGERY)",
    trade_desc_ar: "",
    trade_code: "2109",
  },
  {
    trade_desc: "PEDIATRICIAN (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2110",
  },
  {
    trade_desc: "PEDIATRICIAN (INCLUDING SURGERY)",
    trade_desc_ar: "",
    trade_code: "2111",
  },
  {
    trade_desc: "ORTHOPEDIC SURGERY",
    trade_desc_ar: "",
    trade_code: "2112",
  },
  {
    trade_desc: "NON-SURGICAL SPECIALIST",
    trade_desc_ar: "",
    trade_code: "2113",
  },
  {
    trade_desc: "OBSTETRICIAN AND GYNECOLOGIST",
    trade_desc_ar: "",
    trade_code: "2114",
  },
  {
    trade_desc: "OBSTETRICIAN",
    trade_desc_ar: "",
    trade_code: "2116",
  },
  {
    trade_desc: "HAEMATOLOGIST",
    trade_desc_ar: "",
    trade_code: "2117",
  },
  {
    trade_desc: "GASTROENTEROLOGIST",
    trade_desc_ar: "",
    trade_code: "2119",
  },
  {
    trade_desc: "FORENSIC PATHOLOGIST",
    trade_desc_ar: "",
    trade_code: "2121",
  },
  {
    trade_desc: "EMERGENCY DOCTOR",
    trade_desc_ar: "",
    trade_code: "2122",
  },
  {
    trade_desc: "NEUROLOGY & MENTAL SURGEON",
    trade_desc_ar: "",
    trade_code: "2124",
  },
  {
    trade_desc: "NEUROLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2125",
  },
  {
    trade_desc: "DOCTOR LABORATORY",
    trade_desc_ar: "",
    trade_code: "2126",
  },
  {
    trade_desc: "PULMONOLOGIST",
    trade_desc_ar: "",
    trade_code: "2127",
  },
  {
    trade_desc: "PULMONOLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2128",
  },
  {
    trade_desc: "GASTROENTEROLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2129",
  },
  {
    trade_desc: "INTERNIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2130",
  },
  {
    trade_desc: "INTENSIVE CARE SPECIALIST",
    trade_desc_ar: "",
    trade_code: "2131",
  },
  {
    trade_desc: "EPIDEMIOLOGIST",
    trade_desc_ar: "",
    trade_code: "2132",
  },
  {
    trade_desc: " ENDOCRINOLOGIST (NON -SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2133",
  },
  {
    trade_desc: "RADIOLOGIST NUCLEAR   SPECIALIST",
    trade_desc_ar: "",
    trade_code: "2135",
  },
  {
    trade_desc: "TOXICOLOGIST",
    trade_desc_ar: "",
    trade_code: "2136",
  },
  {
    trade_desc: "ORAL PATHOLOGIST",
    trade_desc_ar: "",
    trade_code: "2137",
  },
  {
    trade_desc: "CONSULTANT (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2138",
  },
  {
    trade_desc: "CONSULTANT (INCLUDING SURGERY)",
    trade_desc_ar: "",
    trade_code: "2139",
  },
  {
    trade_desc: "AUDIOLOGIST",
    trade_desc_ar: "",
    trade_code: "2140",
  },
  {
    trade_desc: "ONCOLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2141",
  },
  {
    trade_desc: "ORAL SURGEON",
    trade_desc_ar: "",
    trade_code: "2142",
  },
  {
    trade_desc: "PARAMEDIC",
    trade_desc_ar: "",
    trade_code: "2143",
  },
  {
    trade_desc: "SPEECH AND AUDIOLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2144",
  },
  {
    trade_desc: "FAMILY MEDICINE",
    trade_desc_ar: "",
    trade_code: "2145",
  },
  {
    trade_desc: "NEPHROLOGIST",
    trade_desc_ar: "",
    trade_code: "2146",
  },
  {
    trade_desc: "DERMATOLOGIST",
    trade_desc_ar: "",
    trade_code: "2147",
  },
  {
    trade_desc: "UROLOGIST",
    trade_desc_ar: "",
    trade_code: "2148",
  },
  {
    trade_desc: "DOCTOR (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2149",
  },
  {
    trade_desc: "OCCUPATIONAL MEDICINE",
    trade_desc_ar: "",
    trade_code: "2150",
  },
  {
    trade_desc: "OTORHINOLARYNGOLOGY HEAD AND NECK SURGERY",
    trade_desc_ar: "",
    trade_code: "2151",
  },
  {
    trade_desc: "NEONATOLOGIST",
    trade_desc_ar: "",
    trade_code: "2152",
  },
  {
    trade_desc: "RADIATION ONCOLOGIST",
    trade_desc_ar: "",
    trade_code: "2154",
  },
  {
    trade_desc: "EAR/NOSE/THROAT DOCTOR (INCLUDING SURGERY)",
    trade_desc_ar: "",
    trade_code: "2155",
  },
  {
    trade_desc: "RHEUMATOLOGIST",
    trade_desc_ar: "",
    trade_code: "2156",
  },
  {
    trade_desc: "CARDIOLOGIST (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2157",
  },
  {
    trade_desc: "THORATIC (NON SURGICAL)",
    trade_desc_ar: "",
    trade_code: "2158",
  },
  {
    trade_desc: "INTERVENTIONAL RADIOLOGIST",
    trade_desc_ar: "",
    trade_code: "2159",
  },
  {
    trade_desc: "NEUROSURGEON",
    trade_desc_ar: "",
    trade_code: "2160",
  },
  {
    trade_desc: "ORTHODONTIST",
    trade_desc_ar: "",
    trade_code: "2161",
  },
  {
    trade_desc: "ALLERGIST & IMMUNOLOGIST",
    trade_desc_ar: "",
    trade_code: "2162",
  },
  {
    trade_desc: "ACUPUNCTURE SPECIALIST",
    trade_desc_ar: "",
    trade_code: "6025",
  },
  {
    trade_desc: "Other",
    trade_desc_ar: "",
    trade_code: "1111",
  },
];

export const onlyNumbersKey = (e) => {
  const charCode = e.charCode;
  // Block Arabic numerals (Unicode ranges: \u0660-\u0669, \u06F0-\u06F9)
  // if ((charCode >= 0x0660 && charCode <= 0x0669) || (charCode >= 0x06F0 && charCode <= 0x06F9)) {
  //   e.preventDefault();
  // }
  const re = /^[0-9]+$/g;
  if (!re.test(e.key) || (charCode >= 0x0660 && charCode <= 0x0669) || (charCode >= 0x06F0 && charCode <= 0x06F9)) {
    e.preventDefault();
  }
};

export const onlyNumbersBackSpaceKey = (e) => {
  const re = /[\d\r\n]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

export const onlyEnglishSpaceKey = (e) => {
  const re = /[a-zA-Z\s]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

export const onlytextkeySpaceKey = (e) => {
  if (e.key) {
    e.replace(/\s/g, "");
  }
};

export const medmalApiRequestCommonData = {
  source: "Portal",
  channelDetails: {
    applicationCategory: "RH",
    branchCode: "85",
    sourceCode: "550541",
    applicationType: "RHSP",
    userName: "EBUSUSER",
    channelCode: "85",
  },
  channelCode: "2",
};
export const medmalApiRequestData = {
  source: "Portal",
  // channelDetails: {
  //   applicationCategory: "RH",
  //   branchCode: "85",
  //   sourceCode: "550541",
  //   applicationType: "RHSP",
  //   userName: "EBUSUSER",
  //   channelCode: "85",
  // },
  channelCode: "2",
};

export const getBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
  reader.onerror = function (error) {};
};

export const generateSha256Hash = async (val) => {
  const utf8 = new TextEncoder().encode(val);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
  return hashHex;
};
export const InjuredPatienCountNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const getFileFormat = (file) => {
  if (isEmpty(file)) return "";
  return file?.name?.split(".").pop()?.toUpperCase() || "PNG";
};

export const getBaseFileFormat = (file) => {
  if (isEmpty(file)) return "";
  switch (file.base64[0]) {
    case "/":
      return "JPEG";
    case "i":
      return "PNG";
    case "R":
      return "GIF";
    case "J":
      return "PDF";
    default:
      return "unknown";
  }
};

export const getBaseFileSize = (file) => {
  if (!file?.base64) return "";
  console.log(file.base64.length / 1e6, "file.Base64###");
  return Math.ceil(file.base64.length / 1e6) || 0;
};

export const getFileSize = (file) => {
  if (!file) return "";
  return Math.ceil(file.size / (1024 * 1024)) || 0;
};

export const downloadBaseFile = (file) => {
  console.log(file, "file###");
  if (!file.base64) return;
  const base64 = file?.base64;
  const name = file?.name;
  var a = document.createElement("a"); //Create <a>
  a.href = "data:image/png;base64," + base64; //Image Base64 Goes here
  a.download = "Image.png"; //File name Here
  a.click(); //Downloaded file
};

export const downloadFile = (file) => {
  console.log(file, "file###");
  if (!file.base64) return;
  const base64 = file?.base64;
  const name = file?.name;
  const downloadLink = document.createElement("a");
  downloadLink.href = base64;
  downloadLink.download = name;
  downloadLink.click();
};

export const claimFileNames = {
  name1: "ComplainMOHletter",
  name2: "PatientMedicalReport",
  name3: "RegistrationCard",
  name4: "Practicing License",
  name5: "AccreditationCertificate",
  name6: "PowerOfAtterny",
  name7: "CourtVerdictCertificate",
};

export const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const months = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export const hijriDays = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
  { label: "25", value: "25" },
  { label: "26", value: "26" },
  { label: "27", value: "27" },
  { label: "28", value: "28" },
  { label: "29", value: "29" },
  { label: "30", value: "30" },
];

export const Days = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
  { label: "25", value: "25" },
  { label: "26", value: "26" },
  { label: "27", value: "27" },
  { label: "28", value: "28" },
  { label: "29", value: "29" },
  { label: "30", value: "30" },
  { label: "31", value: "31" },
];

const defaultPolicyCoverageData = {
  professionId: "",
  isInsuranceHistoryToggle: false,
  insuranceHistoryToggle: {
    nameofInsurer: null,
    policyNumber: "",
    expiryDate: null,
    retroactiveDate: null,
    previousClaim: false,
    previousClaimValue: "",
    negligence: false,
    negligenceValue: "",
    insurerCancel: false,
    insurerCancelValue: "",
  },
  periodofInsurance: 1,
  selectedPolicy: "1",
  selectedAnnual: "1",
};

export const setPolicyCoverageData = (key, value) => {
  const policyCoverageData = localStorage.getItem("policyCoverageData")
    ? JSON.parse(localStorage.getItem("policyCoverageData"))
    : defaultPolicyCoverageData;
  policyCoverageData[key] = value;
  if (key === "isInsuranceHistoryToggle" && value === false)
    policyCoverageData.insuranceHistoryToggle = defaultPolicyCoverageData.insuranceHistoryToggle;
  localStorage.setItem("policyCoverageData", JSON.stringify(policyCoverageData));
};

export const getPolicyCoverageData = (key) => {
  const policyCoverageData = localStorage.getItem("policyCoverageData")
    ? JSON.parse(localStorage.getItem("policyCoverageData"))
    : defaultPolicyCoverageData;
  if (key) {
    return policyCoverageData[key];
  } else {
    return { ...policyCoverageData };
  }
};

export const getExtraMotorMainPath = (location) => {
  try {
    if (location?.pathname.startsWith("/lucid/")) {
      return "lucid";
    } else {
      return "stc";
    }
  } catch (error) {
    return "stc";
  }
};

export const getExtraMotorMainColor = (location) => {
  try {
    if (location?.pathname.startsWith("/lucid/")) {
      return "lucid-main";
    } else if (location?.pathname.startsWith("/stc/")) {
      return "stc-main";
    } else {
      return "bright-purple";
    }
  } catch (error) {
    return "bright-purple";
  }
};

export const getManufactureYearMaxDate = () => {
  let date = new Date();
  const month = date.getMonth() + 1;
  if (month >= 6) {
    date.setFullYear(date.getFullYear() + 1);
  }
  return date;
};

export const getExtraMotorSecondryColor = (location) => {
  try {
    if (location?.pathname.startsWith("/lucid/")) {
      return "lucid-secondry";
    } else if (location?.pathname.startsWith("/stc/")) {
      return "stc-secondry";
    } else {
      return "bright-purple";
    }
  } catch (error) {
    return "bright-purple";
  }
};

export const BUSINESS_LINE_PATHS = {
  BSF: "bsf",
  STC: "stc",
  MOM: "mom",
  LUCID: "lucid",
  CARTRUST: "cartrust",
  SYARAH: "syarah",
  SNB: "snb",
  ALNAGHI: "alnaghi",
  LEAN: "lean",
  PETROMIN: "petromin",
  AUTOHUB: "autohub",
  DEFAULT: undefined,
};

export const BUSINESS_LINE_COLORS = {
  BSF: "#00718A",
  STC: "#4f008c",
  MOM: "#6B47F5",
  LUCID: "#1b1b1b",
  CARTRUST: "#54A8DB",
  SYARAH: "#0D0D75",
  SNB: "#0C7560",
  ALNAGHI: "#6B47F5",
  LEAN: "#2D6F84",
  PETROMIN: "#DC334E",
  DEFAULT: "#6B47F5",
};

export const makeSureMonthWithZero = (val) => {
  if (val <= 9) {
    return val.startsWith("0") ? val : "0" + val;
  } else {
    return val;
  }
};

// Range for Arabic characters
export const onlyArabicValues = (e) => {
  const re = /[\u0600-\u06FF\s]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

export const onlyEnglishValues = (e) => {
  const re = /[a-zA-Z\s]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

// Function to return true if the text contains any English letters
const isEnglish = (text) => /[A-Za-z]/.test(text);

// Function to return true if the text should be considered as only Arabic
export const onlyArabicResult = (text) => {
  // Return true if the text is non-empty and does not contain any English letters
  return text && text.length > 0 && !isEnglish(text);
};

export const decryptData = (encryptedText, secretPass) => {
  try {
    const cleanedData = encryptedText.replace(/ /g, "+");
    cleanedData.replace(" ", "+");
    var key = CryptoJS.enc.Utf8.parse(secretPass);
    var iv = CryptoJS.enc.Utf8.parse(secretPass.substring(0, 16));

    var decrypted = CryptoJS.AES.decrypt(cleanedData, key, { iv: iv, padding: CryptoJS.pad.Pkcs7 });

    const data = decrypted.toString(CryptoJS.enc.Utf8);

    return data;
  } catch (error) {
    // Handle decryption error
  }
};
